export default {
  'header.homepage': 'Page d\'Accueil',
  'header.workspace': 'Espace de Travail',
  'login.title': 'Seedance',
  'login.welcome': 'Bienvenue sur Seedance',
  'login.description': 'Seedance est votre plateforme de génération vidéo IA. Services sûrs et pratiques. Accédez à tous vos fichiers n\'importe quand, n\'importe où.',
  'login.email.placeholder': 'Email ou nom d\'utilisateur',
  'login.password.placeholder': 'Mot de passe',
  'login.button': 'Connexion',
  'login.loading': 'Connexion en cours...',
  'login.divider': 'ou',
  'login.signup': 'Pas encore de compte ?',
  'login.signup.link': 'S\'inscrire',
  'login.error.default': 'Échec de la connexion, veuillez réessayer plus tard',
  'login.success': 'Connexion réussie',
  'login.forgotPassword': 'Mot de passe oublié ?',
  'login.forgotPassword.link': 'Réinitialiser ici',
  'login.rememberPassword': 'Se souvenir du mot de passe',
  'login.social.comingSoon': 'Cette méthode de connexion arrive bientôt',
  'captcha.placeholder': 'Code captcha',
  'captcha.refresh': 'Actualiser le captcha',
  'auth.modal.title': 'Connexion requise',
  'auth.modal.content': 'Votre session a expiré ou vous n\'êtes pas connecté. Veuillez vous connecter pour continuer.',
  'auth.modal.ok': 'Aller à la connexion',
  'auth.modal.cancel': 'Plus tard',
  'signup.title': 'Seedance',
  'signup.welcome': 'Bienvenue sur Seedance',
  'signup.description': 'Créez votre compte et commencez votre voyage de création IA',
  'signup.feature.ai': 'Propulsé par IA',
  'signup.feature.video': 'Création Vidéo',
  'signup.feature.fast': 'Génération Rapide',
  'signup.feature.creative': 'Créativité Illimitée',
  'signup.username.placeholder': 'Entrez le nom d\'utilisateur',
  'signup.email.placeholder': 'Entrez l\'email',
  'signup.password.placeholder': 'Entrez le mot de passe',
  'signup.confirmPassword.placeholder': 'Confirmez le mot de passe',
  'signup.inviteCode.placeholder': "Code d'invitation (facultatif)",
  'signup.button': 'S\'inscrire',
  'signup.loading': 'Inscription en cours...',
  'signup.login': 'Déjà un compte ?',
  'signup.login.link': 'Se connecter',
  'signup.error.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'signup.error.default': 'Échec de l\'inscription, veuillez réessayer plus tard',
  'signup.success': 'Inscription réussie',
  'signup.username.rule.length': 'Le nom d\'utilisateur doit contenir entre 4 et 10 caractères',
  'signup.username.rule.format': 'Seuls les lettres, chiffres, tirets bas et traits d\'union sont autorisés',
  'signup.password.rule.length': 'Le mot de passe doit contenir entre 6 et 20 caractères',
  'signup.password.rule.lowercase': 'Doit contenir des lettres minuscules',
  'signup.password.rule.uppercase': 'Doit contenir des lettres majuscules',
  'signup.password.rule.number': 'Doit contenir des chiffres',
  'signup.password.rule.special': 'Doit contenir des caractères spéciaux',
  'resetPassword.page.title': 'Réinitialisation du mot de passe - Seedance',
  'resetPassword.page.description': 'Réinitialisez votre mot de passe Seedance',
  'resetPassword.title': 'Réinitialiser le mot de passe',
  'resetPassword.email.placeholder': 'Entrez votre adresse e-mail',
  'resetPassword.code.placeholder': 'Entrez le code de vérification',
  'resetPassword.password.placeholder': 'Entrez le nouveau mot de passe',
  'resetPassword.button': 'Réinitialiser',
  'resetPassword.button.loading': 'Réinitialisation...',
  'resetPassword.backToLogin': 'Retour à la connexion',
  'resetPassword.sendCode': 'Obtenir le code',
  'resetPassword.sendCode.sending': 'Envoi...',
  'resetPassword.sendCode.retry': 'Réessayer dans {seconds}s',
  'resetPassword.error.emailRequired': 'Veuillez entrer votre adresse e-mail',
  'resetPassword.error.codeRequired': 'Veuillez entrer le code de vérification',
  'resetPassword.error.passwordRequired': 'Veuillez entrer le nouveau mot de passe',
  'resetPassword.error.passwordLength': 'Le mot de passe doit contenir entre 6 et 20 caractères',
  'resetPassword.error.codeLength': 'Le code de vérification doit contenir 6 chiffres',
  'resetPassword.success.codeSent': 'Le code de vérification a été envoyé à votre e-mail',
  'resetPassword.success.reset': 'Mot de passe réinitialisé avec succès',
  'resetPassword.error.sendFailed': 'Échec de l\'envoi du code de vérification, veuillez réessayer plus tard',
  'resetPassword.error.resetFailed': 'Échec de la réinitialisation du mot de passe, veuillez réessayer plus tard',
  'resetPassword.error.incomplete': 'Veuillez remplir tous les champs obligatoires',
  'resetPassword.subtitle': 'Entrez votre adresse e-mail et un nouveau mot de passe pour réinitialiser l\'accès à votre compte.',
  'resetPassword.email.label': 'E-mail',
  'resetPassword.code.label': 'Code de vérification',
  'resetPassword.password.label': 'Nouveau mot de passe',
  'resetPassword.success.title': 'Réinitialisation réussie',
  'resetPassword.success.description': 'Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
  'resetPassword.goToLogin': 'Se connecter',
  'resetPassword.promo.title': 'Sécurisez votre compte, protégez votre créativité.',
  'resetPassword.promo.description': 'Nous mettons en œuvre des protocoles de sécurité de niveau bancaire pour garantir que vos données et créations vous appartiennent exclusivement.',
  'signup.verificationCode.placeholder': 'Entrez le code de vérification',
  'signup.verificationCode.send': 'Obtenir le code',
  'signup.verificationCode.sending': 'Envoi en cours...',
  'signup.verificationCode.retry': 'Réessayer dans {seconds}s',
  'signup.verificationCode.success': 'Code de vérification envoyé',
  'signup.verificationCode.error': 'Échec de l\'envoi du code',
  'signup.verificationCode.required': 'Veuillez entrer le code de vérification',
  'signup.verificationCode.invalid': 'Format de code de vérification invalide',
  'signup.error.emailRequired': 'Veuillez saisir votre adresse e-mail',
  'signup.announcement': 'La fonction d\'inscription est en maintenance aujourd\'hui !',
  'sidebar.create': 'Créer',
  'sidebar.allFiles': 'Tous les fichiers',
  'sidebar.starred': 'Favoris',
  'sidebar.folders': 'Dossiers',
  'sidebar.trash': 'Corbeille',
  'sidebar.decrypt': 'Outil de déchiffrement',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Chaînes',
  'sidebar.dailyChallenge': 'Défi Quotidien',
  'sidebar.mediaTools': 'Outils Médias',
  'sidebar.storageNodes': 'Nœuds de Stockage',
  'create.tab.textToImage': 'Texte vers Image',
  'create.tab.textToVideo': 'Texte vers Vidéo',
  'create.tab.imageToImage': 'Image vers Image',
  'create.tab.imageToVideo': 'Image vers Vidéo',
  'create.tab.seedanceVideo': 'Seedance Image vers Vidéo',
  'create.seedance.title': 'Seedance Image vers Vidéo',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, génération de vidéos courtes pilotée par l\'image',
  'create.seedance.noModel': 'Aucun modèle Seedance disponible. Veuillez configurer dans l\'administration.',
  'create.seedance.cameraFixed': 'Caméra fixe',
  'create.seedance.cameraFixed.true': 'Oui (fixe)',
  'create.seedance.cameraFixed.false': 'Non (dynamique)',
  'create.seedance.watermark': 'Ajouter un filigrane',
  'create.seedance.watermark.true': 'Oui',
  'create.seedance.watermark.false': 'Non',
  'create.textToImage.title': 'Texte vers Image',
  'create.textToImage.subtitle': 'Entrez une description et laissez l\'IA dessiner l\'image dans votre esprit',
  'create.textToImage.description': 'Générer des images à partir de descriptions textuelles. Cette fonctionnalité est en cours de développement...',
  'create.textToVideo.title': 'Texte vers Vidéo',
  'create.textToVideo.subtitle': 'Entrez des descriptions de scènes et des contrôles de caméra pour générer des vidéos de haute qualité',
  'create.textToVideo.description': 'Générer des vidéos à partir de descriptions textuelles. Cette fonctionnalité est en cours de développement...',
  'create.imageToImage.title': 'Image vers Image',
  'create.imageToImage.description': 'Générer de nouvelles images à partir d\'images de référence. Cette fonctionnalité est en cours de développement...',
  'create.imageToVideo.title': 'Image vers Vidéo',
  'create.imageToVideo.description': 'Générer des vidéos à partir d\'images de référence. Cette fonctionnalité est en cours de développement...',
  'sidebar.feedback': 'Retour',
  'sidebar.about': 'À propos',
  'sidebar.productLog': 'Mises à jour',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Explorez les recettes d\'inspiration IA des meilleurs créateurs et libérez votre potentiel créatif',
  'promptMarket.searchPlaceholder': 'Rechercher prompts, styles, modèles...',
  'promptMarket.search': 'Rechercher',
  'promptMarket.all': 'Tout',
  'promptMarket.tabAll': 'Recommandé',
  'promptMarket.tabImage': 'Texte vers image',
  'promptMarket.tabVideo': 'Texte vers vidéo',
  'promptMarket.tabAudio': 'Texte vers musique',
  'promptMarket.sortLatest': 'Récent',
  'promptMarket.sortHot': 'Populaire',
  'promptMarket.sortSales': 'Meilleures ventes',
  'promptMarket.publish': 'Publier',
  'promptMarket.empty': 'Aucun contenu. Soyez le premier à publier !',
  'promptMarket.free': 'Gratuit',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Échec du chargement',
  'promptMarket.listSuccess': 'Publication réussie',
  'promptMarket.listFailed': 'Échec de la publication',
  'market.label': 'MARCHÉ DE PROMPTS',
  'market.h1': 'Libérez votre',
  'market.h1.highlight': 'intelligence créative.',
  'market.sub': 'La destination premium pour les prompts IA : image, vidéo et musique. Recettes vérifiées pour OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs et plus. Arrêtez de deviner, commencez à créer.',
  'market.providers.title': 'Compatible avec les principaux modèles et plateformes',
  'market.card1.title': 'Intégration instantanée',
  'market.card1.desc': 'Évitez la courbe d\'apprentissage du prompt engineering. Importez des prompts éprouvés en un clic dans votre flux de travail.',
  'market.card2.title': 'Monétisez votre créativité',
  'market.card2.desc': 'Transformez vos meilleurs prompts en revenus passifs. Rejoignez des milliers de créateurs qui gagnent grâce à leur expertise IA.',
  'market.card3.title': 'Qualité vérifiée',
  'market.card3.desc': 'Chaque annonce est révisée et testée manuellement. Nous garantissons des résultats cohérents sur différents modèles.',
  'market.card4.title': 'Explorer le labo',
  'market.card4.desc': 'Découvrez plus de 10 000 actifs générés par la communauté.',
  'market.cta': 'Lancer le Marché de Prompts',
  'home.mediaTools.title': 'Outils médias',
  'home.mediaTools.subtitle': 'Utilisation en ligne, sans installation. Traitez facilement vos images, vidéos et audio.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Compression d\'image',
  'home.mediaTools.imageCompress.description': 'Compression intelligente en préservant la qualité. Traitement par lots.',
  'home.mediaTools.videoCompress.title': 'Compression vidéo',
  'home.mediaTools.videoCompress.description': 'Compression efficace avec résolution et débit personnalisables. Plusieurs formats.',
  'home.mediaTools.audioCompress.title': 'Compression audio',
  'home.mediaTools.audioCompress.description': 'Optimisez la taille en gardant la clarté. MP3, AAC et plus.',
  'filelist.column.name': 'Nom',
  'filelist.column.size': 'Taille',
  'filelist.column.updateTime': 'Modifié',
  'filelist.column.recycletime': 'Date de suppression',
  'filelist.column.actions': 'Actions',
  'filelist.total': 'Total {total} éléments',
  'filelist.action.upload': 'Téléverser',
  'filelist.action.newFolder': 'Nouveau dossier',
  'filelist.action.refresh': 'Actualiser',
  'filelist.action.search': 'Rechercher des fichiers',
  'filelist.action.batchDownload': 'Télécharger',
  'filelist.action.batchDelete': 'Supprimer',
  'filelist.action.download': 'Télécharger',
  'filelist.action.preview': 'Aperçu',
  'filelist.action.rename': 'Renommer',
  'filelist.selected': '{count} sélectionné(s)',
  'page.cloudDrive.title': 'Mon Cloud Drive',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - Stockez et gérez vos fichiers en toute sécurité',
  'modal.fileUpload.title': 'Téléverser des fichiers',
  'modal.fileUpload.dragText': 'Glissez les fichiers ici ou cliquez pour téléverser',
  'modal.fileUpload.start': 'Démarrer le téléversement',
  'modal.fileUpload.cancel': 'Annuler',
  'modal.fileUpload.clear': 'Vider la liste',
  'modal.fileUpload.encrypt': 'Chiffrer la sélection',
  'modal.fileUpload.addMore': 'Ajouter',
  'modal.fileUpload.remove': 'Retirer',
  'modal.fileUpload.error.noSelection': 'Veuillez sélectionner des fichiers à retirer',
  'modal.fileUpload.error.noEncryption': 'Veuillez sélectionner des fichiers à chiffrer',
  'modal.fileUpload.error.noClear': 'Aucun fichier à effacer',
  'modal.fileUpload.error.noStart': 'Aucun fichier à téléverser',
  'modal.fileUpload.error.noCancel': 'Aucun téléversement en cours à annuler',
  'modal.fileUpload.error.fileSize': 'Taille de fichier dépassée',
  'modal.fileUpload.error.fileType': 'Type de fichier non pris en charge',
  'modal.fileUpload.error.maxCount': 'Nombre maximum de fichiers dépassé',
  'modal.fileUpload.duplicate.title': 'Le fichier existe déjà',
  'modal.fileUpload.duplicate.skip': 'Ignorer',
  'modal.fileUpload.duplicate.replace': 'Remplacer',
  'modal.fileUpload.duplicate.rename': 'Renommer',
  'modal.fileUpload.status.pending': 'En attente',
  'modal.fileUpload.status.uploading': 'Téléversement en cours',
  'modal.fileUpload.status.success': 'Terminé',
  'modal.fileUpload.status.error': 'Erreur',
  'modal.fileUpload.status.cancelled': 'Annulé',
  'modal.fileUpload.status.duplicated': 'Dupliqué',
  'modal.fileUpload.table.filename': 'Nom du fichier',
  'modal.fileUpload.table.size': 'Taille',
  'modal.fileUpload.table.status': 'État',
  'modal.fileUpload.table.progress': 'Progression',
  'modal.fileUpload.table.actions': 'Actions',
  'modal.fileUpload.speed': 'Vitesse de téléversement',
  'modal.fileUpload.remainingTime': 'Temps restant',
  'modal.fileUpload.total.progress': 'Progression totale',
  'modal.fileUpload.error.message': 'Échec du téléversement : {message}',
  'modal.fileUpload.confirm.clear': 'Voulez-vous vider la liste de téléversement ?',
  'modal.fileUpload.confirm.cancel': 'Voulez-vous annuler le téléversement ?',
  'modal.fileUpload.clear.mobile': 'Vider',
  'modal.fileUpload.encrypt.mobile': 'Chiffrer',
  'modal.fileUpload.addMore.mobile': 'Ajouter',
  'productLog.title': 'Mises à jour du produit',
  'signup.page.title': 'Inscription - Seedance',
  'security.features.title': 'Fonctionnalités de sécurité',
  'security.features.localDecryption.title': 'Déchiffrement local',
  'security.features.localDecryption.description': 'Toutes les opérations de déchiffrement sont effectuées localement dans votre navigateur, le contenu du fichier et le mot de passe ne quittent jamais votre appareil',
  'security.features.militaryEncryption.title': 'Chiffrement militaire',
  'security.features.militaryEncryption.description': 'Utilise l\'algorithme de chiffrement AES-256-CBC, la norme de chiffrement symétrique la plus sûre qui peut résister à toutes les attaques connues',
  'security.features.privacyProtection.title': 'Protection de la vie privée',
  'security.features.privacyProtection.description': 'Mécanisme strict de protection de la vie privée, aucun mot de passe de déchiffrement n\'est sauvegardé, aucun contenu de fichier n\'est enregistré',
  'security.features.smartDecryption.title': 'Déchiffrement intelligent par blocs',
  'security.features.smartDecryption.description': 'La technologie de déchiffrement intelligent par blocs améliore significativement la vitesse de déchiffrement tout en réduisant l\'utilisation de la mémoire',
  'security.features.learnMore': 'En savoir plus',
  'security.features.modal.title': 'Détails des fonctionnalités de sécurité',
  'security.features.modal.close': 'Fermer',
  'decrypt.security.modal.title': 'Avis de sécurité',
  'decrypt.security.modal.description': 'Toutes les opérations de déchiffrement sont effectuées localement, votre mot de passe et le contenu du fichier ne seront jamais envoyés au serveur',
  'decrypt.security.modal.vip.title': 'En tant qu\'utilisateur VIP, vous pouvez :',
  'decrypt.security.modal.vip.feature1': 'Déchiffrer des fichiers de toute taille',
  'decrypt.security.modal.vip.feature2': 'Utiliser le déchiffrement intelligent par blocs pour une meilleure efficacité',
  'decrypt.security.modal.vip.feature3': 'Prendre en charge le déchiffrement par lots de gros fichiers',
  'decrypt.security.modal.free.title': 'Important : Le processus de déchiffrement nécessite environ 3 fois la taille du fichier en mémoire du navigateur.',
  'decrypt.security.modal.free.feature1': 'Les utilisateurs gratuits sont limités à 4 Go par fichier',
  'decrypt.security.modal.free.feature2': 'Passez en VIP pour déchiffrer des fichiers de toute taille',
  'decrypt.security.modal.free.feature3': 'En cas de plantage du navigateur, envisagez de passer en VIP pour utiliser le déchiffrement par blocs',
  'security.diagram.plaintext.block1': 'Bloc de texte en clair 1',
  'security.diagram.plaintext.block2': 'Bloc de texte en clair 2',
  'security.diagram.ciphertext.block1': 'Bloc de texte chiffré 1',
  'security.diagram.ciphertext.block2': 'Bloc de texte chiffré 2',
  'security.diagram.key': 'Clé',
  'security.diagram.aes.encryption': 'Chiffrement AES',
  'security.diagram.xor.operation': 'Opération XOR',
  'security.diagram.iv': 'Vecteur d\'initialisation',
  'security.features.chunk.title': 'Technologie de Déchiffrement Intelligent par Blocs',
  'security.features.chunk.what': 'Qu\'est-ce que le Déchiffrement Intelligent par Blocs ?',
  'security.features.chunk.description': 'Le déchiffrement intelligent par blocs est une technologie optimisée pour les gros fichiers qui divise les fichiers en plusieurs blocs pour un traitement parallèle, avec les caractéristiques suivantes :',
  'security.features.chunk.feature1.title': 'Division Dynamique',
  'security.features.chunk.feature1.desc': 'Ajuste automatiquement la taille des blocs en fonction de la taille du fichier et de la mémoire système',
  'security.features.chunk.feature2.title': 'Traitement Parallèle',
  'security.features.chunk.feature2.desc': 'Plusieurs blocs de données sont déchiffrés simultanément, utilisant pleinement les CPU multi-cœurs',
  'security.features.chunk.feature3.title': 'Optimisation de la Mémoire',
  'security.features.chunk.feature3.desc': 'Contrôle l\'utilisation de la mémoire via le traitement en streaming pour éviter les débordements',
  'security.features.chunk.feature4.title': 'Support de Reprise',
  'security.features.chunk.feature4.desc': 'Prend en charge la reprise après interruption, améliorant la tolérance aux pannes',
  'security.features.chunk.how': 'Comment ça Fonctionne',
  'security.features.chunk.process': 'Le processus de déchiffrement intelligent par blocs comprend les étapes suivantes :',
  'security.features.chunk.step1': 'Analyse du Fichier : Calcule la taille et le nombre optimal de blocs',
  'security.features.chunk.step2': 'Division des Données : Divise le fichier chiffré en blocs de taille égale',
  'security.features.chunk.step3': 'Déchiffrement Parallèle : Plusieurs blocs sont déchiffrés simultanément',
  'security.features.chunk.step4': 'Écriture en Streaming : Les blocs déchiffrés sont écrits séquentiellement',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Avantages en Performance',
  'security.features.chunk.performance.intro': 'Par rapport au déchiffrement traditionnel, le déchiffrement intelligent par blocs présente des avantages significatifs :',
  'security.features.chunk.performance.point1': 'Utilisation de la mémoire réduite jusqu\'à 90%, seulement 400Mo nécessaires pour un fichier de 4Go',
  'security.features.chunk.performance.point2': 'Vitesse de déchiffrement 3-5 fois plus rapide, utilisant les CPU multi-cœurs',
  'security.features.chunk.performance.point3': 'Prend en charge le déchiffrement de gros fichiers (>4Go), non limité par la mémoire du navigateur',
  'security.features.chunk.performance.point4': 'Processus de déchiffrement visuel avec progression et temps restant précis',
  'security.features.chunk.usage': 'Cas d\'Utilisation',
  'security.features.chunk.usage.intro': 'Le déchiffrement intelligent par blocs est particulièrement adapté aux scénarios suivants :',
  'security.features.chunk.usage.point1': 'Déchiffrement de gros fichiers (ex. vidéos, sauvegardes de base de données)',
  'security.features.chunk.usage.point2': 'Opérations de déchiffrement sur des appareils à mémoire limitée',
  'security.features.chunk.usage.point3': 'Déchiffrement par lots nécessitant un traitement parallèle',
  'security.features.chunk.usage.point4': 'Tâches de déchiffrement nécessitant un retour en temps réel',
  'security.features.chunk.diagram': 'Diagramme du Processus de Déchiffrement par Blocs',
  'security.features.aes.security': 'Caractéristiques de sécurité',
  'security.features.aes.security.intro': 'AES-256-CBC offre plusieurs garanties de sécurité :',
  'security.features.aes.security.point1': 'La clé de 256 bits offre 2^256 combinaisons possibles, impossible à casser par force brute même avec un superordinateur',
  'security.features.aes.security.point2': 'Le mode CBC garantit que des blocs de texte en clair identiques produisent des blocs chiffrés différents, augmentant la randomisation du chiffrement',
  'security.features.aes.security.point3': 'L\'utilisation du vecteur d\'initialisation (IV) garantit que même avec la même clé, chaque chiffrement produit un résultat différent',
  'security.features.aes.security.point4': 'Largement utilisé dans les domaines militaires, financiers et autres domaines nécessitant une haute sécurité',
  'security.features.aes.diagram': 'Diagramme dynamique du processus de chiffrement en mode CBC',
  'security.features.aes.why': 'Pourquoi choisir AES-256-CBC ?',
  'security.features.aes.why.intro': 'Nous avons choisi AES-256-CBC comme standard de chiffrement pour les raisons suivantes :',
  'security.features.aes.why.point1': 'Sécurité largement validée, aucune méthode d\'attaque pratique à ce jour',
  'security.features.aes.why.point2': 'Excellentes performances, chiffrement et déchiffrement rapides',
  'security.features.aes.why.point3': 'Support d\'accélération matérielle, instructions AES intégrées dans les processeurs modernes',
  'security.features.aes.why.point4': 'Large support d\'outils, implémentations matures dans tous les langages de programmation',
  'security.features.aes.what': 'Qu\'est-ce que AES-256-CBC ?',
  'security.features.aes.description': 'AES-256-CBC est une implémentation du Standard de Chiffrement Avancé (Advanced Encryption Standard), où :',
  'security.features.aes.detail.1': 'Un algorithme de chiffrement symétrique établi par l\'Institut National des Standards et de la Technologie (NIST) des États-Unis en 2001',
  'security.features.aes.detail.2': 'Utilise une longueur de clé de 256 bits, offrant le plus haut niveau de sécurité',
  'security.features.aes.detail.3': 'Le mode Chaînage des Blocs de Chiffrement (CBC) fournit une meilleure sécurité de chiffrement',
  'security.features.aes.how': 'Comment ça fonctionne',
  'security.features.aes.process': 'Le processus de chiffrement AES-256-CBC comprend les étapes suivantes :',
  'security.features.aes.step1': 'Diviser les données en clair en blocs de taille fixe (128 bits)',
  'security.features.aes.step2': 'Générer un vecteur d\'initialisation (IV) aléatoire',
  'security.features.aes.step3': 'Effectuer une opération XOR entre le bloc de texte chiffré précédent et le bloc de texte en clair actuel en utilisant le mode CBC',
  'security.features.aes.step4': 'Utiliser la clé de 256 bits pour effectuer le chiffrement AES sur le résultat du XOR',
  'security.features.aes.example': 'Exemple de processus de chiffrement :',
  'decrypt.fileList.column.name': 'Nom du fichier',
  'decrypt.fileList.column.status': 'État',
  'decrypt.fileList.column.actions': 'Actions',
  'decrypt.fileList.status.pending': 'En attente',
  'decrypt.fileList.status.decrypting': 'Déchiffrement',
  'decrypt.fileList.status.success': 'Terminé',
  'decrypt.fileList.status.error': 'Erreur',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'Aucun fichier, veuillez ajouter des fichiers à déchiffrer',
  'common.unknown': 'Inconnu',
  'common.philosophy': 'La technologie doit servir le peuple',
  'common.speed': 'Vitesse',
  'common.timeSpent': 'Temps écoulé',
  'common.remaining': 'Restant',
  'decrypt.upload.dragText': 'Cliquez ou glissez des fichiers',
  'decrypt.upload.hint': 'Prend en charge les fichiers .encrypted, maximum {maxSize} par fichier',
  'decrypt.upload.button.decrypt': 'Déchiffrer la sélection',
  'decrypt.upload.button.clear': 'Vider la liste',
  'decrypt.fileInfo.modal.title': 'Informations sur le fichier',
  'decrypt.fileInfo.modal.close': 'Fermer',
  'decrypt.fileInfo.name': 'Nom du fichier',
  'decrypt.fileInfo.size': 'Taille du fichier',
  'decrypt.fileInfo.type': 'Type de fichier',
  'decrypt.fileInfo.lastModified': 'Dernière modification',
  'decrypt.fileInfo.status': 'État',
  'decrypt.fileInfo.progress': 'Progression',
  'decrypt.fileInfo.speed': 'Vitesse',
  'decrypt.fileInfo.timeRemaining': 'Temps restant',
  'decrypt.fileInfo.timeSpent': 'Temps écoulé',
  'decrypt.fileInfo.error': 'Message d\'erreur',
  'filelist.modal.rename.title': 'Renommer',
  'filelist.modal.rename.placeholder': 'Entrez le nouveau nom',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Annuler',
  'page.decrypt.title': 'Outil de déchiffrement de fichiers MyStorage',
  'page.decrypt.subtitle': 'Déchiffrez vos fichiers en toute sécurité',
  'page.decrypt.helmet.title': 'Outil de déchiffrement - MyStorage',
  'page.decrypt.helmet.description': 'Outil de déchiffrement sécurisé - Déchiffrez vos fichiers localement dans le navigateur pour protéger votre confidentialité',
  'decrypt.message.invalidFile': 'Veuillez sélectionner uniquement des fichiers .encrypted',
  'decrypt.message.duplicate': 'Le fichier "{filename}" existe déjà, dédoublonnage automatique effectué',
  'decrypt.message.oversizeTitle': 'Taille de fichier dépassée',
  'decrypt.message.oversizeContent': 'Les fichiers suivants dépassent la limite gratuite (4 Go) :',
  'decrypt.message.oversizeHint': 'Passez en VIP pour déchiffrer des fichiers de toute taille',
  'decrypt.message.selectFile': 'Veuillez sélectionner des fichiers à déchiffrer',
  'decrypt.message.enterPassword': 'Veuillez entrer le mot de passe de déchiffrement',
  'decrypt.message.decryptSuccess': 'Le fichier {filename} a été enregistré',
  'decrypt.message.saveCancel': 'Enregistrement du fichier {filename} annulé',
  'decrypt.message.downloadSuccess': 'Le fichier {filename} a été enregistré dans le dossier de téléchargement',
  'decrypt.message.decryptError': 'Échec du déchiffrement du fichier {filename} : {error}',
  'decrypt.message.batchError': 'Échec du déchiffrement par lots, veuillez réessayer',
  'decrypt.password.modal.title': 'Entrez le mot de passe de déchiffrement',
  'decrypt.password.modal.placeholder': 'Entrez le mot de passe',
  'decrypt.password.modal.hint': 'Entrez le mot de passe défini lors du chiffrement, il ne sera utilisé que pour le déchiffrement local',
  'modal.newFolder.title': 'Nouveau dossier',
  'modal.newFolder.placeholder': 'Entrez le nom du dossier',
  'modal.newFolder.ok': 'Créer',
  'modal.newFolder.cancel': 'Annuler',
  'sideMenu.storageInfo.title': 'Espace de stockage',
  'sideMenu.storageInfo.usage': 'Utilisé {used} / Total {total}',
  'sideMenu.storageStats.title': 'Statistiques de stockage',
  'sideMenu.storageStats.overview': 'Aperçu',
  'sideMenu.storageStats.totalFiles': 'Total des fichiers',
  'sideMenu.storageStats.totalSize': 'Taille totale',
  'sideMenu.storageStats.fileTypes': 'Distribution des types de fichiers',
  'sideMenu.storageStats.providers': 'Fournisseurs de services',
  'common.default': 'Par défaut',
  'common.regionCode': 'Code de région',
  'common.nodeType': 'Type de nœud',
  'common.storageUsed': 'Espace utilisé',
  'common.storageAvailable': 'Espace disponible',
  'common.storageLimit': 'Capacité totale',
  'common.storageUsageDetail': 'Utilisé {used} / Total {total}',
  'common.defaultNode': 'Nœud par défaut',
  'common.confirm': 'Confirmer',
  'common.cancel': 'Annuler',
  'common.latency': 'Latence',
  'common.retry': 'Réessayer',
  'cloudDrive.nodeSelect.title': 'Sélectionner un nœud de stockage',
  'cloudDrive.nodeSelect.addNode': 'Ajouter un nœud de stockage',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmer la suppression du nœud',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Êtes-vous sûr de vouloir supprimer le nœud "{nodeName}" ? Cette action ne peut pas être annulée !',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nœud supprimé avec succès',
  'cloudDrive.nodeSelect.deleteFailed': 'Échec de la suppression du nœud',
  
  // Création de nœud
  'cloudDrive.nodeCreate.title': 'Ajouter un nœud de stockage',
  'cloudDrive.nodeCreate.selectProvider': 'Sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.nodeName': 'Nom du nœud',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Laisser vide pour utiliser le nom par défaut',
  'cloudDrive.nodeCreate.nameMaxLength': 'Le nom du nœud ne peut pas dépasser 50 caractères',
  'cloudDrive.nodeCreate.noProviders': 'Aucun fournisseur cloud disponible',
  'cloudDrive.nodeCreate.pingLatency': 'Latence {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Test de latence en cours...',
  'cloudDrive.nodeCreate.pingFailed': 'Échec du test de latence',
  'cloudDrive.nodeCreate.pingUnavailable': 'Test de latence non disponible',
  'cloudDrive.nodeCreate.sortByLatency': 'Trier par latence',
  'cloudDrive.nodeCreate.selectRegion': 'Sélectionner une région',
  'cloudDrive.nodeCreate.selectedRegion': 'Région sélectionnée',
  'cloudDrive.nodeCreate.noRegions': 'Aucune région disponible',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Veuillez sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Veuillez d\'abord sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Veuillez d\'abord sélectionner une région',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Erreur lors du chargement de la liste des fournisseurs cloud',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Erreur lors du chargement de la liste des régions',
  'cloudDrive.nodeCreate.nodeType': 'Type de nœud',
  'cloudDrive.nodeCreate.nodeType.standard': 'Stockage standard',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Stockage basse fréquence',
  'cloudDrive.nodeCreate.nodeType.archive': 'Stockage d\'archive',
  'cloudDrive.nodeCreate.storageLimit': 'Limite de stockage',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Veuillez entrer la limite de stockage',
  'cloudDrive.nodeCreate.storageLimitMin': 'La limite de stockage ne peut pas être inférieure à 1 Go',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Entrez la limite de stockage (Go)',
  'cloudDrive.nodeCreate.success': 'Nœud de stockage créé avec succès',
  'cloudDrive.nodeCreate.failed': 'Échec de la création du nœud de stockage',
  
  // Édition de nœud
  'cloudDrive.nodeEdit.title': 'Modifier le nœud',
  'cloudDrive.nodeEdit.name': 'Nom du nœud',
  'cloudDrive.nodeEdit.nameRequired': 'Veuillez entrer le nom du nœud',
  'cloudDrive.nodeEdit.nameMaxLength': 'Le nom du nœud ne peut pas dépasser 50 caractères',
  
  // TextToImage page internationalization
  'create.prompt': 'Invite',
  'create.prompt.placeholder': 'ex.: un chat cyberpunk marchant dans l\'espace, fond néon, détails élevés...',
  'create.prompt.required': 'Veuillez entrer une invite',
  'create.prompt.generate': 'IA Générer Invite',
  'create.prompt.enrich': 'IA Enrichir Invite',
  'create.prompt.generate.success': 'Invite générée avec succès !',
  'create.prompt.generate.error': 'Échec de la génération de l\'invite, veuillez réessayer',
  'create.prompt.generate.empty': 'Aucune invite générée, veuillez réessayer',
  'create.prompt.restore': 'Restaurer',
  'create.prompt.restore.success': 'Restauré à l\'invite originale',
  'create.prompt.restore.tooltip': 'Restaurer à l\'invite avant la génération/enrichissement de l\'IA',
  'create.negativePrompt': 'Invite Négative',
  'create.ratio': 'Ratio d\'Aspect',
  'create.style': 'Style Artistique',
  'create.batchSize': 'Taille du Lot',
  'create.generate': 'Générer Maintenant',
  'create.negativePrompt.tooltip': 'Éléments que vous ne voulez pas dans l\'image',
  'create.negativePrompt.placeholder': 'ex.: flou, basse qualité, doigts déformés...',
  'create.generating': 'Génération en cours...',
  'create.generating.waiting': 'L\'IA crée, veuillez patienter...',
  'create.result.title': 'Résultats Générés',
  'create.downloadAll': 'Tout Télécharger',
  'create.aspectRatio.1:1': '1:1 (Carré)',
  'create.aspectRatio.16:9': '16:9 (Paysage)',
  'create.aspectRatio.9:16': '9:16 (Portrait)',
  'create.aspectRatio.21:9': '21:9 (Cinéma)',
  'create.aspectRatio.4:3': '4:3 (Classique)',
  'create.style.general': 'Général',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Réaliste',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Échec du chargement des paramètres de type de création, affichage de toutes les options',
  'create.settings.error': 'Échec du chargement des paramètres, affichage de toutes les options',
  'create.noAvailableTabs': 'Aucun type de création disponible',
  'create.network.error.title': 'Erreur de Connexion Réseau',
  'create.network.error.description': 'Impossible de charger les paramètres de type de création. Veuillez vérifier votre connexion réseau et actualiser la page',
  'create.network.error.refresh': 'Actualiser la Page',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Description de Scène Vidéo (Prompt)',
  'create.prompt.video.placeholder': 'ex., Un chien astronaute dansant sur la surface lunaire, 8K, éclairage cinématographique, surréalisme.',
  'create.prompt.video.required': 'Veuillez entrer une description de scène vidéo',
  'create.generate.video': 'Générer la Vidéo Maintenant',
  'create.video.ratio': 'Ratio d\'Aspect Vidéo',
  'create.video.camera': 'Mouvement de Caméra',
  'create.video.duration': 'Durée Vidéo (secondes)',
  'create.video.format': 'Format de Sortie',
  'create.cameraMotion.none': 'Aucun Mouvement (None)',
  'create.cameraMotion.zoomIn': 'Zoom Avant (Zoom In)',
  'create.cameraMotion.dollyOut': 'Recul (Dolly Out)',
  'create.cameraMotion.panLeft': 'Panoramique Gauche (Pan Left)',
  'create.cameraMotion.tiltUp': 'Inclinaison Haut (Tilt Up)',
  'create.cameraMotion.orbital': '360° Orbital',
  'create.negativePrompt.video.placeholder': 'ex., filigranes, scintillement, basse résolution, personnages flous...',
  'create.sora.thinking': 'Sora réfléchit...',
  'create.video.analyzing': 'Analyse de l\'image et du prompt, l\'IA est en train de créer...',
  'create.video.info': 'Durée: {duration}s | Ratio: {ratio}',
  'create.video.preview': 'Aperçu Vidéo',
  'create.video.result': 'Aperçu Vidéo Final',
  'create.video.empty': 'Les résultats générés s\'afficheront ici',
  'create.download': 'Télécharger la Vidéo',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Estimé: {price}',
  'create.model.select': 'Sélectionner un Modèle',
  'create.model.loading': 'Chargement des modèles...',
  'create.model.loadFailed': 'Échec du chargement de la liste des modèles',
  'create.model.family.select': 'Sélectionner une Famille de Modèles',
  'create.model.family.select.placeholder': 'Veuillez sélectionner une famille de modèles',
  'create.model.family.loadFailed': 'Échec du chargement de la liste des familles de modèles',
  'create.style.select.placeholder': 'Veuillez sélectionner un style artistique (optionnel, par défaut utilise le modèle de famille)',
  'create.model.style.loadFailed': 'Échec du chargement de la liste des modèles de style',
  'create.model.description': 'Description du Modèle',
  'create.model.aspectResolution': 'Résolution d\'Aspect',
  'create.model.fps': 'Fréquence d\'Images',
  'create.model.features': 'Fonctionnalités Supportées',
  'create.model.feature.cameraMotion': 'Mouvement de Caméra',
  'create.model.feature.img2video': 'Image vers Vidéo',
  'create.model.feature.videoEdit': 'Édition Vidéo',
  'create.model.price.perSecond': '/sec',
  'create.model.detail': 'Détails',
  'create.history.title': 'Historique de génération',
  'create.history.refresh': 'Actualiser',
  'create.history.empty': 'Aucun historique de génération',
  'create.history.total': 'Total {total} enregistrements',
  'create.history.status.queued': 'En file d\'attente',
  'create.history.status.processing': 'En cours',
  'create.history.status.success': 'Succès',
  'create.history.status.failed': 'Échec',
  'create.history.status.timeout': 'Délai d\'attente dépassé',
  'create.history.failed.noImage': 'Génération échouée',
  'create.history.downloadAll.start': 'Début du téléchargement de {count} images',
  'create.history.downloadAll.tooltip': 'Télécharger toutes les {count} images',
  'create.history.download.tooltip': 'Télécharger l\'image',
  'create.history.detail.tooltip': 'Voir les détails',
  'create.history.noPrompt': 'Pas de prompt',
  'create.history.deleteConfirm.title': 'Confirmer la suppression',
  'create.history.deleteConfirm.content': 'Êtes-vous sûr de vouloir supprimer cette tâche ? Cette action est irréversible.',
  'create.history.deleteSuccess': 'Supprimé avec succès',
  'create.history.deleteFailed': 'Échec de la suppression',
  'create.taskDetail.title': 'Détails de la tâche',
  'create.taskDetail.loading': 'Chargement...',
  'create.taskDetail.loadFailed': 'Échec du chargement des détails de la tâche',
  'create.taskDetail.noData': 'Aucune donnée disponible',
  'create.taskDetail.basicInfo': 'Informations de base',
  'create.taskDetail.model': 'Modèle',
  'create.taskDetail.taskType': 'Type de tâche',
  'create.taskDetail.createTime': 'Heure de création',
  'create.taskDetail.duration': 'Durée de génération',
  'create.taskDetail.prompt': 'Invite',
  'create.taskDetail.error': 'Message d\'erreur',
  'create.taskDetail.outputFiles': 'Fichiers de sortie',
  'create.taskDetail.downloadAll': 'Tout télécharger',
  'create.taskDetail.downloadAll.start': 'Début du téléchargement de {count} images',
  'create.taskDetail.modelInfo': 'Informations sur le modèle',
  'create.taskDetail.defaultResolution': 'Résolution par défaut',
  'create.taskDetail.maxResolution': 'Résolution maximale',
  'create.taskDetail.aspectRatios': 'Proportions prises en charge',
  'create.taskDetail.formats': 'Formats pris en charge',
  'create.taskDetail.prompt.copied': 'Invite copiée',
  'create.taskDetail.liked': 'Aimé',
  'create.taskDetail.like': 'J\'aime',
  'create.taskDetail.collected': 'Collecté',
  'create.taskDetail.collect': 'Collecter',
  'create.taskDetail.linkCopied': 'Lien copié',
  'create.taskDetail.share': 'Partager',
  'create.taskDetail.outputs': 'Sorties',
  'create.taskDetail.preview': 'Aperçu',
  'create.taskDetail.download': 'Télécharger',
  'create.taskDetail.generationFailed': 'Génération échouée',
  'create.taskDetail.generating': 'Génération en cours...',
  'create.taskDetail.promptLabel': 'Invite',
  'create.taskDetail.copy': 'Copier',
  'create.taskDetail.executionStats': 'Statistiques d\'exécution',
  'create.taskDetail.creditsCost': 'Coût des crédits',
  'create.taskDetail.modelSpecs': 'Spécifications du modèle',
  'create.taskDetail.capabilities': 'Fonctionnalités',
  'create.taskDetail.supportedRatios': 'Proportions prises en charge',
  'create.taskDetail.dataError': 'Erreur de données',
  'create.taskDetail.more': 'Plus',
  'create.taskDetail.downloading': 'Téléchargement en cours...',
  'create.taskDetail.points': 'pts',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'SUCCÈS',
  'create.taskDetail.status.failed': 'ÉCHOUÉ',
  'create.taskDetail.status.processing': 'TRAITEMENT EN COURS',
  'create.taskDetail.status.queued': 'EN FILE D\'ATTENTE',
  'create.taskDetail.status.generating': 'GÉNÉRATION',
  'create.taskDetail.durationLabel': 'Durée',
  'create.taskDetail.taskParams': 'Paramètres de la tâche',
  'create.taskDetail.aspectRatio': 'Ratio d\'aspect',
  'create.taskDetail.inputType': 'Type d\'entrée',
  'create.taskDetail.modelCode': 'Code du modèle',
  'create.taskDetail.regenerate': 'Régénérer',
  'create.taskDetail.feature.developing': 'Fonction en développement',
  'create.taskDetail.result': 'Résultat de la génération',
  'create.taskDetail.copyPrompt': 'Copier l\'invite',
  'create.taskDetail.imageDimensions': 'Dimensions',
  'create.taskDetail.fileSize': 'Taille du fichier',
  'create.taskDetail.loadingImageInfo': 'Chargement des informations de l\'image...',
  'create.history.failed.noVideo': 'Génération échouée',
  'create.video.generate.cancelled.polling': 'Interrogation de la tâche annulée',
  'create.video.generate.queued': 'Tâche de génération vidéo soumise, en file d\'attente...',
  'create.video.generate.noUrl': 'Génération vidéo terminée, mais URL vidéo introuvable',
  'create.video.status.checkFailed': 'Échec de la vérification du statut de la tâche',
  'create.video.generate.processing': 'Tâche de génération vidéo soumise, traitement en cours...',
  'create.video.taskQueue': 'File d\'attente des tâches',
  'create.video.polling': 'Génération de la vidéo, veuillez patienter...',
  'create.video.ratio.invalid': 'Veuillez sélectionner un ratio d\'aspect vidéo pris en charge par le modèle',
  'create.waitingTask.queue': 'File d\'attente des tâches',
  'create.waitingTask.empty': 'Aucune tâche en cours',
  'create.waitingTask.generating': 'Génération...',
  'create.waitingTask.queued': 'En file d\'attente',
  'create.waitingTask.cancel': 'Annuler la tâche',
  // HistorySection nouvelle internationalisation
  'create.history.copyPrompt': 'Copier le prompt',
  'create.history.download': 'Télécharger',
  'create.history.delete': 'Supprimer',
  'create.history.generating': 'Génération...',
  'create.history.generationFailed': 'Échec de la génération',
  'create.history.noPreview': 'Aucun aperçu',
  // ImageToVideo nouvelle internationalisation
  'create.i2v.fileType.error': 'Veuillez sélectionner un fichier image',
  'create.i2v.fileSize.error': 'La taille du fichier image ne peut pas dépasser 10 Mo',
  'create.i2v.imageSize.error': 'La hauteur de l\'image doit être d\'au moins {minHeight}px, la taille actuelle de l\'image est {width}x{height}px',
  'create.i2v.fileRead.error': 'Échec de la lecture de l\'image',
  'create.i2v.replaceImage': 'Remplacer l\'image',
  'create.i2v.upload.supportedFormats': 'Supports JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Veuillez télécharger une image de référence',
  'create.i2v.upload': 'Télécharger l\'Image de Référence (Image de Départ)',
  'create.i2v.upload.click': 'Cliquez ou glissez-déposez pour télécharger',
  'create.i2v.prompt.required': 'Veuillez entrer une description de guidage de mouvement',
  'create.i2v.uploading.image': 'Téléchargement de l\'image vers le cloud...',
  'create.i2v.upload.success': 'Image téléchargée avec succès',
  'create.i2v.upload.failed': 'Échec du téléchargement de l\'image, veuillez réessayer',
  'create.i2v.original': 'Original (image de départ)',
  'create.i2v.result': 'Comparaison de génération',
  'create.i2v.empty': 'La comparaison des résultats générés et de l\'image originale sera affichée ici',
  'create.generate.i2v': 'Commencer la génération vidéo',
  'create.prompt.i2v.placeholder': 'Ex: Faire marcher la personne dans l\'image, les feuilles en arrière-plan se balancent dans le vent...',
  'create.prompt.enhance.tooltip': 'Enrichir le prompt avec l\'IA pour rendre la description plus détaillée et vivante',
  'create.prompt.enhance': 'Enrichir avec l\'IA',
  'create.prompt.enhance.empty': 'Veuillez d\'abord entrer un prompt de base',
  'create.prompt.enhance.success': 'Prompt enrichi avec succès !',
  'create.prompt.enhance.empty.result': 'Aucun prompt enrichi généré, veuillez réessayer',
  'create.prompt.enhance.error': 'Échec de l\'enrichissement du prompt, veuillez réessayer',
  'create.prompt.version.history': 'Historique des Versions',
  'create.prompt.version.history.tooltip': 'Voir l\'historique des versions du prompt',
  // TaskDetailModal nouvelle internationalisation
  'create.taskDetail.unnamedTask': 'Tâche sans nom',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Coût en tokens',
  'create.taskDetail.publish': 'Publier dans la communauté',
  'create.taskDetail.selectCover': 'Sélectionner la couverture',
  'create.taskDetail.selectChannel': 'Sélectionner le canal',
  'create.taskDetail.selectChallenge': 'Sélectionner le défi',
  'create.taskDetail.publishSuccess': 'Publié avec succès',
  'create.taskDetail.loadChannelsFailed': 'Échec du chargement des canaux',
  'create.taskDetail.loadChallengesFailed': 'Échec du chargement des défis',
  'create.taskDetail.publishFailed': 'Échec de la publication',
  'create.taskDetail.daysLeft': 'Il reste {days} jours',
  // ModelDetailModal nouvelle internationalisation
  'create.model.capability.t2v': 'T2V (Texte vers Vidéo)',
  'create.model.capability.img2video': 'Image vers Vidéo',
  'create.model.capability.videoEdit': 'Édition Vidéo',
  'create.model.capability.characterConsistency': 'Cohérence des Personnages',
  'create.model.capability.reference': 'Référence',
  'create.model.capability.cameraMotion': 'Mouvement de Caméra',
  'create.model.aspectRatios': 'Ratios d\'Aspect',
  'create.model.resolution': 'Résolution',
  'create.model.resolution.default': 'Par défaut',
  'create.model.resolution.max': 'Max',
  'create.model.duration': 'Durée',
  'create.model.formats': 'Formats',
  'create.model.like': 'J\'aime',
  'create.model.liked': 'Aimé',
  'create.model.unliked': 'Non aimé',
  'create.model.favorite': 'Favori',
  'create.model.favorited': 'Ajouté aux favoris',
  'create.model.unfavorited': 'Retiré des favoris',
  'create.model.share': 'Partager',
  'create.model.linkCopied': 'Lien copié',
  'create.model.capabilities': 'Capacités',
  'create.model.free': 'Gratuit',
  'create.model.tokenCost.display': '{count} token',
  // Autres nouvelles clés
  'create.aspectRatio.portrait': 'Portrait',
  'create.aspectRatio.landscape': 'Paysage',
  'create.video.ratio.placeholder': 'Veuillez sélectionner le ratio d\'aspect vidéo',
  'create.video.format.placeholder': 'Veuillez sélectionner le format de sortie',
  'create.video.style': 'Style Vidéo',
  'create.video.style.tooltip': 'Sélectionner le style de génération vidéo',
  'create.video.style.placeholder': 'Veuillez sélectionner le style vidéo',
  'create.video.quality': 'Qualité Vidéo',
  'create.video.quality.tooltip': 'Sélectionner la qualité de génération vidéo',
  'create.video.quality.placeholder': 'Veuillez sélectionner la qualité vidéo',
  'create.duration.select.placeholder': 'Veuillez sélectionner la durée vidéo',
  'create.model.select.placeholder': 'Veuillez d\'abord sélectionner un modèle',
  'video.not.supported': 'Votre navigateur ne prend pas en charge la lecture vidéo.',
  // UnderDevelopment Internationalisation
  'underDevelopment.comingSoon': 'Bientôt disponible',
  'underDevelopment.title': 'Fonction en développement',
  'underDevelopment.subtitle': 'Nous travaillons dur pour développer cette fonctionnalité, restez à l\'écoute !',
  'underDevelopment.backHome': 'Retour à l\'accueil',
  'underDevelopment.goBack': 'Retour',
  // UserMenu Internationalisation
  'userMenu.email.notBound': 'Email non lié',
  'userMenu.status.verified': 'Vérifié',
  'userMenu.status.guest': 'Invité',
  'userMenu.recharge': 'Recharger maintenant',
  'userMenu.community': 'Communauté',
  'userMenu.group.account': 'Paramètres du compte',
  'userMenu.group.assets': 'Actifs et commandes',
  'userMenu.group.workspace': 'Espace de travail',
  'userMenu.group.support': 'Support',
  'userMenu.item.profile': 'Profil',
  'userMenu.item.settings': 'Paramètres',
  'userMenu.item.security': 'Sécurité',
  'userMenu.item.privacy': 'Confidentialité',
  'userMenu.item.wallet': 'Mon portefeuille',
  'userMenu.item.subscription': 'Abonnement',
  'userMenu.item.orders': 'Historique des commandes',
  'userMenu.item.works': 'Mes œuvres',
  'userMenu.item.notifications': 'Notifications',
  'userMenu.item.help': 'Centre d\'aide',
  'userMenu.item.invite': 'Inviter des amis',
  'userMenu.item.feedback': 'Commentaires',
  'userMenu.item.about': 'À propos de nous',
  'userMenu.level': 'Niveau',
  'userMenu.member.vip1': 'Membre de base',
  'userMenu.member.vip2': 'Membre argent',
  'userMenu.member.vip3': 'Membre or',
  'userMenu.member.vip4': 'Membre diamant',
  'userMenu.member.vip5': 'Membre ultime',
  'userMenu.logout': 'Déconnexion',
  // Recharge Agreement Internationalisation
  'rechargeAgreement.back': 'Retour',
  'rechargeAgreement.title': 'Accord de Service de Recharge',
  'rechargeAgreement.lastUpdated': 'Dernière mise à jour : ',
  'rechargeAgreement.goRecharge': 'Aller à la Recharge',
  'rechargeAgreement.section1.title': 'I. Portée de l\'Accord',
  'rechargeAgreement.section1.content1': 'Cet accord est un accord juridique entre vous et la plateforme concernant les services de recharge. Avant d\'utiliser le service de recharge, veuillez lire attentivement tout le contenu de cet accord. Si vous n\'êtes pas d\'accord avec un contenu de cet accord, ou si vous ne pouvez pas comprendre avec précision la signification des termes pertinents, veuillez ne pas effectuer d\'opérations de recharge.',
  'rechargeAgreement.section1.content2': 'En cliquant sur "Accepter" ou en effectuant des opérations de recharge, vous indiquez que vous avez lu, compris et accepté tout le contenu de cet accord.',
  'rechargeAgreement.section2.title': 'II. Instructions de Recharge',
  'rechargeAgreement.section2.subtitle1': '2.1 Méthodes de Recharge',
  'rechargeAgreement.section2.content1': 'La plateforme prend en charge les méthodes de recharge suivantes :',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Carte Bancaire (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'Cryptomonnaie USDT (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Devise de Recharge',
  'rechargeAgreement.section2.content2': 'La plateforme prend en charge la recharge dans les devises suivantes : CNY, USD, USDT. Une conversion de taux de change peut exister entre différentes devises, et le taux de change spécifique est soumis au taux de change en temps réel au moment de la recharge.',
  'rechargeAgreement.section2.subtitle3': '2.3 Limites de Recharge',
  'rechargeAgreement.section2.limit1': 'Recharge minimale unique : 1 yuan (ou équivalent en autres devises)',
  'rechargeAgreement.section2.limit2': 'Recharge maximale unique : 50 000 yuans (ou équivalent en autres devises)',
  'rechargeAgreement.section2.limit3': 'Limite de recharge cumulative quotidienne : 100 000 yuans (ou équivalent en autres devises)',
  'rechargeAgreement.section2.note': 'Remarque : Les limites de recharge peuvent varier en fonction de la méthode de paiement, du niveau de compte et d\'autres facteurs. Veuillez consulter la page de recharge pour plus de détails.',
  'rechargeAgreement.section3.title': 'III. Arrivée de la Recharge',
  'rechargeAgreement.section3.subtitle1': '3.1 Temps d\'Arrivée',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay : Arrivée en temps réel',
  'rechargeAgreement.section3.time2': 'Carte Bancaire : 1-3 jours ouvrables',
  'rechargeAgreement.section3.time3': 'USDT : Selon le temps de confirmation de la blockchain, généralement 10-30 minutes',
  'rechargeAgreement.section3.subtitle2': '3.2 Traitement des Exceptions',
  'rechargeAgreement.section3.content1': 'Si la recharge n\'arrive pas à temps, veuillez conserver le justificatif de paiement et contacter le service client immédiatement. La plateforme traitera votre problème de recharge dès que possible après vérification.',
  'rechargeAgreement.section4.title': 'IV. Politique de Remboursement',
  'rechargeAgreement.section4.important': 'Important : Après une recharge réussie, le solde du compte ne prend pas en charge le remboursement direct. Le solde ne peut être utilisé que pour la consommation de services dans la plateforme.',
  'rechargeAgreement.section4.subtitle1': '4.1 Conditions de Remboursement',
  'rechargeAgreement.section4.content1': 'Vous pouvez demander un remboursement dans les cas suivants :',
  'rechargeAgreement.section4.refund1': 'Recharge en double due à une panne du système de la plateforme',
  'rechargeAgreement.section4.refund2': 'Service indisponible en raison de la plateforme, et le solde du compte n\'a pas été consommé',
  'rechargeAgreement.section4.refund3': 'Autres circonstances spéciales approuvées par la plateforme après examen',
  'rechargeAgreement.section4.subtitle2': '4.2 Processus de Remboursement',
  'rechargeAgreement.section4.process1': 'Soumettre une demande de remboursement et expliquer la raison',
  'rechargeAgreement.section4.process2': 'Examen de la plateforme (généralement 3-7 jours ouvrables)',
  'rechargeAgreement.section4.process3': 'Après approbation, le remboursement sera retourné à votre compte de paiement',
  'rechargeAgreement.section5.title': 'V. Sécurité du Compte',
  'rechargeAgreement.section5.content1': 'Vous êtes responsable de la conservation appropriée des informations de votre compte et du mot de passe. La plateforme n\'est pas responsable des pertes causées par le vol de compte ou la fuite de mot de passe dus à vos propres raisons.',
  'rechargeAgreement.section5.content2': 'Si vous constatez des anomalies de compte, veuillez contacter immédiatement le service client et modifier votre mot de passe. La plateforme vous aidera à traiter les problèmes connexes.',
  'rechargeAgreement.section6.title': 'VI. Clause de Non-Responsabilité',
  'rechargeAgreement.section6.disclaimer1': 'La plateforme n\'est pas responsable des interruptions de service causées par des cas de force majeure (tels que catastrophes naturelles, guerre, actions gouvernementales, etc.)',
  'rechargeAgreement.section6.disclaimer2': 'Pour les problèmes de recharge causés par des pannes de plateformes de paiement tierces, la plateforme aidera au traitement mais n\'assume pas de responsabilité directe',
  'rechargeAgreement.section6.disclaimer3': 'Les pertes causées par les violations de l\'utilisateur de cet accord ou des lois et réglementations pertinentes seront supportées par l\'utilisateur lui-même',
  'rechargeAgreement.section7.title': 'VII. Modification de l\'Accord',
  'rechargeAgreement.section7.content1': 'La plateforme a le droit de modifier cet accord selon les besoins de développement commercial. Après modification de l\'accord, il sera annoncé dans un endroit proéminent sur la plateforme. Si vous continuez à utiliser le service de recharge, cela est considéré comme une acceptation de l\'accord modifié.',
  'rechargeAgreement.section8.title': 'VIII. Informations de Contact',
  'rechargeAgreement.section8.content1': 'Si vous avez des questions sur cet accord, ou si vous devez demander un remboursement ou traiter des problèmes de recharge, veuillez nous contacter via les méthodes suivantes :',
  'rechargeAgreement.section8.contact1': 'Email du Service Client : support@example.com',
  'rechargeAgreement.section8.contact2': 'Service Client en Ligne : Jours ouvrables 9h00-18h00',
  'rechargeAgreement.section8.contact3': 'Centre d\'Aide : Voir la FAQ',
  // Internationalisation du profil
  'profile.editProfile': 'Modifier le Profil',
  'profile.creditScore': 'Score de Crédit',
  'profile.level': 'Niveau',
  'profile.balance': 'Solde',
  'profile.tab.basic': 'Informations de Base',
  'profile.tab.account': 'Actifs du Compte',
  'profile.section.personal': 'Informations Personnelles',
  'profile.section.contact': 'Contact',
  'profile.section.wallet': 'Portefeuille USDT',
  'profile.label.username': 'Nom d\'Utilisateur',
  'profile.label.realName': 'Nom Réel',
  'profile.label.accountStatus': 'État du Compte',
  'profile.label.phone': 'Numéro de Téléphone',
  'profile.label.email': 'Email',
  'profile.label.registerTime': 'Heure d\'Inscription',
  'profile.label.availableBalance': 'Solde Disponible',
  'profile.label.frozenAmount': 'Montant Gelé',
  'profile.value.notVerified': 'Non Vérifié',
  'profile.value.notBound': 'Non Lié',
  'profile.value.noAddress': 'Pas d\'Adresse TRC20',
  'profile.value.noDescription': 'Cette personne est paresseuse et n\'a rien écrit',
  'profile.status.normal': 'Normal',
  'profile.status.disabled': 'Désactivé',
  'profile.tooltip.verified': 'Vérifié',
  'profile.tooltip.unverified': 'Vérifier Maintenant',
  'profile.banner.construction': 'Cette page est en construction...',
  'profile.modal.title': 'Modifier le Profil',
  'profile.modal.cancel': 'Annuler',
  'profile.modal.save': 'Enregistrer les Modifications',
  'profile.modal.avatarSection': 'Paramètres d\'Avatar',
  'profile.modal.basicSection': 'Informations de Base',
  'profile.modal.contactSection': 'Informations de Contact',
  'profile.modal.changeAvatar': 'Changer l\'Avatar',
  'profile.modal.avatarHint': 'Formats supportés JPG, PNG, maximum 2MB',
  'profile.modal.nickname': 'Surnom',
  'profile.modal.nicknamePlaceholder': 'Entrez votre surnom',
  'profile.modal.description': 'Biographie',
  'profile.modal.descriptionPlaceholder': 'Présentez-vous en une phrase...',
  'profile.modal.phone': 'Téléphone',
  'profile.modal.email': 'Email',
  'profile.message.avatarSizeLimit': 'La taille de l\'image ne peut pas dépasser 2MB',
  'profile.message.avatarUploadSuccess': 'Avatar téléchargé avec succès',
  'profile.message.saveSuccess': 'Enregistré avec succès',
  'profile.message.saveFailed': 'Échec de l\'enregistrement',
  'profile.message.uploadAvatarFailed': 'Échec du téléchargement de l\'avatar',
  'profile.message.operationFailed': 'Opération échouée',
  'privacyPreferences.title': 'Préférences de Confidentialité',
  'privacyPreferences.description': 'Gérez vos paramètres de confidentialité et contrôlez la façon dont nous collectons et utilisons vos données',
  'privacyPreferences.back': 'Retour',
  'privacyPreferences.save': 'Enregistrer les Paramètres',
  'privacyPreferences.saveSuccess': 'Préférences de confidentialité enregistrées avec succès',
  'privacyPreferences.saveError': 'Échec de l\'enregistrement, veuillez réessayer plus tard',
  'privacyPreferences.required': 'Requis',
  'privacyPreferences.info': 'Vos préférences de confidentialité seront enregistrées localement et appliquées automatiquement lors de votre prochaine visite. Connectez-vous pour synchroniser les paramètres avec le cloud.',
  'privacyPreferences.info.loggedIn': 'Vos préférences de confidentialité seront enregistrées dans votre compte et synchronisées sur tous vos appareils. Vous pouvez revenir à cette page pour modifier ces paramètres à tout moment.',
  'cookieBanner.message': 'Nous utilisons les cookies et le stockage local pour la connexion, le thème et les fonctionnalités de base. En continuant, vous acceptez notre politique de confidentialité.',
  'cookieBanner.acceptAll': 'Tout accepter',
  'cookieBanner.essentialOnly': 'Essentiel uniquement',
  'cookieBanner.settings': 'Préférences',
  'privacyPreferences.cookies.title': 'Préférences de Cookies',
  'privacyPreferences.cookies.description': 'Les cookies nous aident à fournir une meilleure expérience de service. Vous pouvez choisir d\'accepter ou de refuser certains types de cookies.',
  'privacyPreferences.cookies.essential': 'Cookies Essentiels',
  'privacyPreferences.cookies.essential.desc': 'Ces cookies sont nécessaires au bon fonctionnement du site Web et ne peuvent pas être désactivés. Ils sont généralement utilisés pour la sécurité, la connexion et les fonctionnalités de base.',
  'privacyPreferences.cookies.functional': 'Cookies Fonctionnels',
  'privacyPreferences.cookies.functional.desc': 'Ces cookies permettent au site Web de mémoriser vos choix et de fournir des fonctionnalités améliorées et une expérience personnalisée.',
  'privacyPreferences.cookies.analytics': 'Cookies d\'Analyse',
  'privacyPreferences.cookies.analytics.desc': 'Ces cookies nous aident à comprendre comment les visiteurs utilisent le site Web afin que nous puissions améliorer nos services.',
  'privacyPreferences.cookies.marketing': 'Cookies Marketing',
  'privacyPreferences.cookies.marketing.desc': 'Ces cookies sont utilisés pour suivre votre activité de navigation afin de vous afficher des publicités et du contenu pertinents.',
  'privacyPreferences.data.title': 'Préférences de Collecte de Données',
  'privacyPreferences.data.description': 'Contrôlez la façon dont nous collectons et utilisons vos données pour améliorer l\'expérience de service.',
  'privacyPreferences.data.collection': 'Collecte de Données',
  'privacyPreferences.data.collection.desc': 'Autorisez-nous à collecter les données d\'utilisation nécessaires pour fournir et améliorer les services.',
  'privacyPreferences.data.analytics': 'Analyse de Données',
  'privacyPreferences.data.analytics.desc': 'Autorisez-nous à analyser vos modèles d\'utilisation pour optimiser les performances du service et l\'expérience utilisateur.',
  'privacyPreferences.data.personalization': 'Personnalisation',
  'privacyPreferences.data.personalization.desc': 'Autorisez-nous à fournir du contenu et des recommandations personnalisés basés sur vos préférences et habitudes d\'utilisation.',
  'privacyPreferences.marketing.title': 'Préférences Marketing',
  'privacyPreferences.marketing.description': 'Choisissez les types de communications marketing que vous souhaitez recevoir.',
  'privacyPreferences.marketing.emails': 'E-mails Marketing',
  'privacyPreferences.marketing.emails.desc': 'Recevez des notifications par e-mail concernant les mises à jour de produits, les promotions et les offres spéciales.',
  'privacyPreferences.marketing.sms': 'SMS Marketing',
  'privacyPreferences.marketing.sms.desc': 'Recevez des notifications SMS concernant les mises à jour importantes et les promotions.',
  'privacyPreferences.marketing.push': 'Notifications Push',
  'privacyPreferences.marketing.push.desc': 'Recevez des notifications push du navigateur, y compris les mises à jour de produits et les messages importants.',
  'privacyPreferences.thirdParty.title': 'Partage de Données avec des Tiers',
  'privacyPreferences.thirdParty.description': 'Contrôlez si vous autorisez le partage de vos données avec des fournisseurs de services tiers.',
  'privacyPreferences.thirdParty.sharing': 'Partage de Données avec des Tiers',
  'privacyPreferences.thirdParty.sharing.desc': 'Autorisez-nous à partager des données d\'utilisation anonymisées avec des fournisseurs de services tiers de confiance pour améliorer les services.',
  
  // Politique de Confidentialité
  'privacyPolicy.title': 'Politique de Confidentialité',
  'privacyPolicy.lastUpdated': 'Dernière mise à jour : {date}',
  'privacyPolicy.intro1': 'Cette Politique de Confidentialité décrit comment la plateforme AIMATEX (ci-après dénommée "nous" ou "cette plateforme") collecte, utilise, stocke et protège vos informations personnelles lorsque vous utilisez nos services, ainsi que vos droits en matière de confidentialité. Nous accordons une grande importance à la protection de votre vie privée. Veuillez lire attentivement cette Politique de Confidentialité.',
  'privacyPolicy.intro2': 'L\'utilisation de nos services signifie que vous acceptez cette Politique de Confidentialité. Si vous n\'acceptez pas une partie de cette Politique de Confidentialité, veuillez ne pas utiliser nos services.',
  'privacyPolicy.section1.title': 'I. Informations que nous collectons',
  'privacyPolicy.section1.1.title': '1.1 Informations que vous fournissez',
  'privacyPolicy.section1.1.intro': 'Lors de l\'utilisation de ce service, vous devrez peut-être fournir les informations suivantes :',
  'privacyPolicy.section1.1.item1.label': 'Informations de compte',
  'privacyPolicy.section1.1.item1.desc': 'Nom d\'utilisateur, adresse e-mail, mot de passe, numéro de téléphone, etc.',
  'privacyPolicy.section1.1.item2.label': 'Informations de profil',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, pseudonyme, biographie, etc. (optionnel)',
  'privacyPolicy.section1.1.item3.label': 'Informations de paiement',
  'privacyPolicy.section1.1.item3.desc': 'Méthodes de paiement, adresse de facturation, etc. (pour le traitement des paiements)',
  'privacyPolicy.section1.1.item4.label': 'Contenu généré',
  'privacyPolicy.section1.1.item4.desc': 'Invites de texte, images de référence, vidéos, musique, images, modèles 3D générés, etc. que vous téléchargez',
  'privacyPolicy.section1.2.title': '1.2 Informations collectées automatiquement',
  'privacyPolicy.section1.2.intro': 'Lorsque vous utilisez ce service, nous pouvons collecter automatiquement les informations suivantes :',
  'privacyPolicy.section1.2.item1.label': 'Informations sur l\'appareil',
  'privacyPolicy.section1.2.item1.desc': 'Type d\'appareil, système d\'exploitation, type et version du navigateur, identifiants d\'appareil, etc.',
  'privacyPolicy.section1.2.item2.label': 'Données d\'utilisation',
  'privacyPolicy.section1.2.item2.desc': 'Heure d\'accès, pages visitées, fonctionnalités utilisées, enregistrements d\'opérations, etc.',
  'privacyPolicy.section1.2.item3.label': 'Informations réseau',
  'privacyPolicy.section1.2.item3.desc': 'Adresse IP, type de réseau, opérateur réseau, etc.',
  'privacyPolicy.section1.2.item4.label': 'Informations de journal',
  'privacyPolicy.section1.2.item4.desc': 'Journaux d\'erreurs, données de performance, etc.',
  'privacyPolicy.section1.3.title': '1.3 Cookies et technologies similaires',
  'privacyPolicy.section1.3.intro': 'Nous utilisons des cookies et des technologies similaires pour :',
  'privacyPolicy.section1.3.item1': 'Maintenir votre état de connexion',
  'privacyPolicy.section1.3.item2': 'Mémoriser vos préférences (comme la langue, le thème, etc.)',
  'privacyPolicy.section1.3.item3': 'Analyser l\'utilisation du service pour améliorer la qualité du service',
  'privacyPolicy.section1.3.item4': 'Fournir une expérience personnalisée',
  'privacyPolicy.section1.3.note': 'Vous pouvez refuser les cookies via les paramètres du navigateur, mais cela peut affecter l\'utilisation de certaines fonctionnalités.',
  'privacyPolicy.section2.title': 'II. Objectif de l\'utilisation des informations',
  'privacyPolicy.section2.intro': 'Nous collectons et utilisons vos informations aux fins suivantes :',
  'privacyPolicy.section2.item1.label': 'Fournir des services',
  'privacyPolicy.section2.item1.desc': 'Traiter vos demandes de génération de contenus (vidéos, musique, images, modèles 3D, etc.), gérer votre compte et vos œuvres, etc.',
  'privacyPolicy.section2.item2.label': 'Améliorer les services',
  'privacyPolicy.section2.item2.desc': 'Analyser l\'utilisation, optimiser les performances du service et l\'expérience utilisateur',
  'privacyPolicy.section2.item3.label': 'Gestion de compte',
  'privacyPolicy.section2.item3.desc': 'Vérifier l\'identité, traiter les paiements, envoyer des notifications, etc.',
  'privacyPolicy.section2.item4.label': 'Sécurité',
  'privacyPolicy.section2.item4.desc': 'Détecter et prévenir la fraude, l\'abus, les menaces de sécurité, etc.',
  'privacyPolicy.section2.item5.label': 'Support client',
  'privacyPolicy.section2.item5.desc': 'Répondre à vos demandes, traiter les plaintes et les commentaires, etc.',
  'privacyPolicy.section2.item6.label': 'Conformité légale',
  'privacyPolicy.section2.item6.desc': 'Se conformer aux exigences légales, coopérer avec les enquêtes des forces de l\'ordre, etc.',
  'privacyPolicy.section3.title': 'III. Partage et divulgation d\'informations',
  'privacyPolicy.section3.1.title': '3.1 Nous ne vendons pas vos informations personnelles',
  'privacyPolicy.section3.1.content': 'Nous ne vendons, ne louons ni n\'échangeons vos informations personnelles avec des tiers.',
  'privacyPolicy.section3.2.title': '3.2 Fournisseurs de services',
  'privacyPolicy.section3.2.intro': 'Nous pouvons partager des informations avec les types de fournisseurs de services suivants :',
  'privacyPolicy.section3.2.item1.label': 'Fournisseurs de services cloud',
  'privacyPolicy.section3.2.item1.desc': 'Pour le stockage et le traitement des données',
  'privacyPolicy.section3.2.item2.label': 'Fournisseurs de services de paiement',
  'privacyPolicy.section3.2.item2.desc': 'Pour le traitement des transactions de paiement',
  'privacyPolicy.section3.2.item3.label': 'Fournisseurs de services d\'analyse',
  'privacyPolicy.section3.2.item3.desc': 'Pour analyser l\'utilisation du service',
  'privacyPolicy.section3.2.item4.label': 'Fournisseurs de services de support client',
  'privacyPolicy.section3.2.item4.desc': 'Pour fournir un support client',
  'privacyPolicy.section3.2.note': 'Ces fournisseurs de services ne peuvent utiliser les informations que pour nous fournir des services et non à d\'autres fins.',
  'privacyPolicy.section3.3.title': '3.3 Exigences légales',
  'privacyPolicy.section3.3.intro': 'Nous pouvons divulguer vos informations dans les circonstances suivantes :',
  'privacyPolicy.section3.3.item1': 'Se conformer aux lois, règlements, ordonnances judiciaires ou exigences gouvernementales',
  'privacyPolicy.section3.3.item2': 'Protéger nos droits, propriété ou sécurité',
  'privacyPolicy.section3.3.item3': 'Prévenir ou enquêter sur des activités illégales possibles',
  'privacyPolicy.section3.3.item4': 'Protéger la sécurité des utilisateurs ou du public',
  'privacyPolicy.section3.4.title': '3.4 Transfert d\'entreprise',
  'privacyPolicy.section3.4.content': 'En cas de fusion, d\'acquisition ou de transfert d\'actifs, vos informations peuvent être transférées. Nous vous en informerons avant le transfert.',
  'privacyPolicy.section4.title': 'IV. Stockage et sécurité des informations',
  'privacyPolicy.section4.1.title': '4.1 Lieu de stockage',
  'privacyPolicy.section4.1.content': 'Vos informations peuvent être stockées sur des serveurs situés en République populaire de Chine ou à l\'étranger. Nous prendrons des mesures appropriées pour assurer la sécurité des informations.',
  'privacyPolicy.section4.2.title': '4.2 Période de conservation',
  'privacyPolicy.section4.2.intro': 'Nous ne conservons vos informations que pendant la période nécessaire :',
  'privacyPolicy.section4.2.item1': 'Informations de compte : pendant la durée de votre compte et pendant une période après sa suppression',
  'privacyPolicy.section4.2.item2': 'Contenu généré : conservé selon vos paramètres ou les exigences légales',
  'privacyPolicy.section4.2.item3': 'Données d\'utilisation : généralement conservées pendant une période plus courte pour l\'analyse et l\'amélioration du service',
  'privacyPolicy.section4.3.title': '4.3 Mesures de sécurité',
  'privacyPolicy.section4.3.intro': 'Nous prenons les mesures de sécurité suivantes pour protéger vos informations :',
  'privacyPolicy.section4.3.item1': 'Transmission et stockage cryptés',
  'privacyPolicy.section4.3.item2': 'Contrôle d\'accès et authentification',
  'privacyPolicy.section4.3.item3': 'Audits de sécurité réguliers et analyses de vulnérabilités',
  'privacyPolicy.section4.3.item4': 'Formation des employés et accords de confidentialité',
  'privacyPolicy.section4.3.note': 'Veuillez noter qu\'aucune mesure de sécurité n\'est sûre à 100%. Nous ne pouvons garantir une sécurité absolue des informations.',
  'privacyPolicy.section5.title': 'V. Vos droits',
  'privacyPolicy.section5.intro': 'Conformément aux lois et règlements applicables, vous avez les droits suivants :',
  'privacyPolicy.section5.item1.label': 'Droit d\'accès',
  'privacyPolicy.section5.item1.desc': 'Consulter vos informations personnelles que nous détenons',
  'privacyPolicy.section5.item2.label': 'Droit de rectification',
  'privacyPolicy.section5.item2.desc': 'Corriger les informations inexactes ou incomplètes',
  'privacyPolicy.section5.item3.label': 'Droit à l\'effacement',
  'privacyPolicy.section5.item3.desc': 'Demander la suppression de vos informations personnelles (sauf si la loi exige leur conservation)',
  'privacyPolicy.section5.item4.label': 'Droit de retirer le consentement',
  'privacyPolicy.section5.item4.desc': 'Retirer votre consentement au traitement des informations',
  'privacyPolicy.section5.item5.label': 'Droit à la portabilité des données',
  'privacyPolicy.section5.item5.desc': 'Obtenir une copie de vos informations personnelles',
  'privacyPolicy.section5.item6.label': 'Droit d\'opposition',
  'privacyPolicy.section5.item6.desc': 'Vous opposer à certaines activités de traitement des informations',
  'privacyPolicy.section5.note': 'Pour exercer les droits ci-dessus, veuillez nous contacter via les coordonnées à la fin de cette Politique de Confidentialité.',
  'privacyPolicy.section6.title': 'VI. Protection des mineurs',
  'privacyPolicy.section6.content1': 'Ce service s\'adresse principalement aux utilisateurs de plus de 18 ans. Si vous avez moins de 18 ans, veuillez utiliser ce service avec le consentement et sous la supervision de votre tuteur.',
  'privacyPolicy.section6.content2': 'Si nous découvrons que nous avons collecté des informations personnelles d\'utilisateurs de moins de 18 ans sans le consentement du tuteur, nous supprimerons les informations pertinentes dès que possible.',
  'privacyPolicy.section7.title': 'VII. Liens tiers',
  'privacyPolicy.section7.content': 'Ce service peut contenir des liens vers des sites Web tiers. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites Web tiers. Lors de la visite de ces sites, veuillez consulter leur politique de confidentialité.',
  'privacyPolicy.section8.title': 'VIII. Modifications de la Politique de Confidentialité',
  'privacyPolicy.section8.content1': 'Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre. Les modifications importantes vous seront notifiées au moins 30 jours avant leur entrée en vigueur. La poursuite de l\'utilisation du service indique votre acceptation de la Politique de Confidentialité mise à jour.',
  'privacyPolicy.section8.content2': 'Nous mettrons à jour la date de "Dernière mise à jour" en haut de cette page et vous informerons des modifications importantes par e-mail ou par des notifications dans l\'application.',
  'privacyPolicy.section9.title': 'IX. Nous contacter',
  'privacyPolicy.section9.intro': 'Si vous avez des questions, commentaires ou plaintes concernant cette Politique de Confidentialité, veuillez nous contacter par les moyens suivants :',
  'privacyPolicy.section9.email': 'E-mail : {email}',
  'privacyPolicy.section9.hours': 'Heures de service client : jours ouvrables 9h00-18h00',
  'privacyPolicy.section9.response': 'Nous répondrons à votre demande dans un délai raisonnable.',
  
  // Conditions d'Utilisation
  'termsOfService.title': 'Conditions d\'Utilisation',
  'termsOfService.lastUpdated': 'Dernière mise à jour : {date}',
  'termsOfService.intro': 'Avant d\'utiliser nos services, veuillez lire attentivement ces Conditions d\'Utilisation. En accédant ou en utilisant la plateforme AIMATEX (ci-après dénommée "cette plateforme" ou "service"), vous acceptez d\'être lié par ces Conditions d\'Utilisation. Si vous n\'acceptez pas une partie de ces Conditions d\'Utilisation, veuillez ne pas utiliser nos services.',
  'termsOfService.section1.title': 'I. Définitions et Interprétation',
  'termsOfService.section1.1.title': '1.1 Définitions',
  'termsOfService.section1.1.intro': 'Dans ces Conditions d\'Utilisation, sauf indication contraire du contexte, les termes suivants ont les significations suivantes :',
  'termsOfService.section1.1.item1.label': '"Plateforme" ou "Cette Plateforme"',
  'termsOfService.section1.1.item1.desc': 'Désigne la plateforme de service de génération de vidéos AIMATEX, y compris mais sans s\'y limiter, les sites Web, les applications mobiles et les services connexes.',
  'termsOfService.section1.1.item2.label': '"Nous", "Notre", "Société"',
  'termsOfService.section1.1.item2.desc': 'Désigne l\'opérateur de la plateforme AIMATEX, à savoir ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Vous", "Utilisateur"',
  'termsOfService.section1.1.item3.desc': 'Désigne tout individu, entreprise ou autre entité juridique qui accède ou utilise ce service.',
  'termsOfService.section1.1.item4.label': '"Service"',
  'termsOfService.section1.1.item4.desc': 'Désigne toutes les fonctionnalités et services fournis par cette plateforme, y compris mais sans s\'y limiter, la génération de vidéos, musique, images, modèles 3D IA et autres contenus, la sélection de modèles, la gestion des œuvres, la gestion des comptes utilisateurs, etc.',
  'termsOfService.section1.1.item5.label': '"Contenu"',
  'termsOfService.section1.1.item5.desc': 'Désigne tout texte, image, vidéo, audio et autres matériaux téléchargés, générés, créés ou partagés par les utilisateurs via cette plateforme.',
  'termsOfService.section1.1.item6.label': '"Contenu Généré"',
  'termsOfService.section1.1.item6.desc': 'Désigne les vidéos, musique, images, modèles 3D et autres œuvres générées par les utilisateurs en utilisant les modèles IA de cette plateforme.',
  'termsOfService.section1.1.item7.label': '"Compte"',
  'termsOfService.section1.1.item7.desc': 'Désigne le compte utilisateur enregistré par l\'utilisateur sur cette plateforme.',
  'termsOfService.section2.title': 'II. Description du Service',
  'termsOfService.section2.1.title': '2.1 Contenu du Service',
  'termsOfService.section2.1.intro': 'Cette plateforme fournit des services complets de génération de contenus IA, y compris mais sans s\'y limiter :',
  'termsOfService.section2.1.item1': 'Génération de texte vers médias (vidéos, musique, images, modèles 3D, etc.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Génération d\'image vers médias (vidéos, modèles 3D, etc.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Gestion et affichage de diverses œuvres générées',
  'termsOfService.section2.1.item4': 'Sélection et gestion de modèles',
  'termsOfService.section2.1.item5': 'Comptes utilisateurs et centre personnel',
  'termsOfService.section2.1.item6': 'Services d\'abonnement et de paiement',
  'termsOfService.section2.2.title': '2.2 Modifications du Service',
  'termsOfService.section2.2.content': 'Nous nous réservons le droit de modifier, suspendre ou résilier tout ou partie des services à tout moment sans préavis. Nous ne sommes pas responsables des pertes causées par les modifications du service.',
  'termsOfService.section3.title': 'III. Comptes Utilisateurs',
  'termsOfService.section3.1.title': '3.1 Inscription au Compte',
  'termsOfService.section3.1.intro': 'L\'utilisation de ce service nécessite l\'enregistrement d\'un compte. Lors de l\'enregistrement, vous acceptez de :',
  'termsOfService.section3.1.item1': 'Fournir des informations d\'enregistrement vraies, précises et complètes',
  'termsOfService.section3.1.item2': 'Mettre à jour les informations d\'enregistrement en temps opportun pour les maintenir vraies, précises et complètes',
  'termsOfService.section3.1.item3': 'Être responsable de toutes les activités sous votre compte',
  'termsOfService.section3.1.item4': 'Garder votre mot de passe de compte en sécurité et ne pas transférer, vendre ou prêter votre compte à d\'autres',
  'termsOfService.section3.2.title': '3.2 Restriction d\'Âge',
  'termsOfService.section3.2.content': 'Vous devez avoir au moins 18 ans pour utiliser ce service. Si vous avez moins de 18 ans, veuillez utiliser ce service avec le consentement et sous la supervision de votre tuteur.',
  'termsOfService.section3.3.title': '3.3 Sécurité du Compte',
  'termsOfService.section3.3.content': 'Vous êtes responsable de maintenir la sécurité de votre compte. Si vous découvrez que votre compte a été compromis ou qu\'il existe une vulnérabilité de sécurité, veuillez nous en informer immédiatement. Nous ne sommes pas responsables des pertes causées par votre échec à protéger correctement les informations de votre compte.',
  'termsOfService.section4.title': 'IV. Règles d\'Utilisation',
  'termsOfService.section4.1.title': '4.1 Activités Interdites',
  'termsOfService.section4.1.intro': 'Lors de l\'utilisation de ce service, vous ne devez pas :',
  'termsOfService.section4.1.item1': 'Générer, télécharger ou partager tout contenu illégal, nuisible, menaçant, abusif, harcelant, diffamatoire, vulgaire, obscène, portant atteinte à la vie privée ou aux droits de propriété intellectuelle d\'autrui',
  'termsOfService.section4.1.item2': 'Générer ou diffuser de fausses informations, du contenu trompeur ou malveillant',
  'termsOfService.section4.1.item3': 'Utiliser ce service pour toute fraude commerciale, blanchiment d\'argent ou autres activités illégales',
  'termsOfService.section4.1.item4': 'Perturber ou détruire le fonctionnement normal de cette plateforme, y compris mais sans s\'y limiter, l\'utilisation d\'outils automatisés, de robots d\'exploration, de virus, etc.',
  'termsOfService.section4.1.item5': 'Accéder sans autorisation à tout système, données ou compte de cette plateforme',
  'termsOfService.section4.1.item6': 'Copier, modifier, distribuer, vendre ou louer toute partie de cette plateforme',
  'termsOfService.section4.1.item7': 'Effectuer une ingénierie inverse, décompiler ou désassembler tout logiciel de cette plateforme',
  'termsOfService.section4.2.title': '4.2 Responsabilité du Contenu',
  'termsOfService.section4.2.content': 'Vous êtes entièrement responsable de tout contenu généré, téléchargé ou partagé via cette plateforme. Nous ne pré-examinons pas le contenu généré par les utilisateurs, mais nous nous réservons le droit de supprimer le contenu violant à tout moment.',
  'termsOfService.section5.title': 'V. Propriété Intellectuelle',
  'termsOfService.section5.1.title': '5.1 Propriété Intellectuelle de la Plateforme',
  'termsOfService.section5.1.content': 'Tous les droits de propriété intellectuelle de cette plateforme, y compris mais sans s\'y limiter, les marques, brevets, droits d\'auteur, secrets commerciaux, etc., appartiennent à nous ou aux titulaires de droits concernés. Vous ne pouvez pas les utiliser sans autorisation.',
  'termsOfService.section5.2.title': '5.2 Contenu Généré par l\'Utilisateur',
  'termsOfService.section5.2.content': 'Les droits de propriété intellectuelle du contenu que vous générez via cette plateforme vous appartiennent. Cependant, vous nous accordez un droit non exclusif, mondial, gratuit et sous-licenciable d\'utiliser, afficher et distribuer votre contenu pour fournir et améliorer les services.',
  'termsOfService.section5.3.title': '5.3 Modèles IA',
  'termsOfService.section5.3.content': 'Les droits de propriété intellectuelle des modèles IA (y compris les modèles Sora) utilisés par cette plateforme appartiennent à leurs développeurs. Vous ne pouvez pas copier, modifier ou distribuer ces modèles.',
  'termsOfService.section6.title': 'VI. Services Payants',
  'termsOfService.section6.1.title': '6.1 Modèles de Paiement',
  'termsOfService.section6.1.content': 'Cette plateforme propose deux modèles de paiement : abonnement et paiement à l\'usage. Les prix spécifiques et les méthodes de facturation sont soumis aux annonces de la plateforme.',
  'termsOfService.section6.2.title': '6.2 Paiement',
  'termsOfService.section6.2.content': 'Vous acceptez de payer les frais de service selon les prix annoncés par la plateforme. Tous les frais sont facturés en RMB ou en autres devises supportées par la plateforme. Après un paiement réussi, les frais ne sont pas remboursables, sauf disposition contraire de la loi ou engagement de notre part.',
  'termsOfService.section6.3.title': '6.3 Politique de Remboursement',
  'termsOfService.section6.3.content': 'Sauf disposition contraire de la loi ou engagement de notre part, les frais payés ne sont pas remboursables. Si le service ne peut pas être utilisé normalement en raison de problèmes de la plateforme, nous fournirons un remboursement ou une compensation selon la situation réelle.',
  'termsOfService.section7.title': 'VII. Disponibilité du Service',
  'termsOfService.section7.1.title': '7.1 Interruption du Service',
  'termsOfService.section7.1.intro': 'Nous ne sommes pas responsables des interruptions de service causées par les raisons suivantes :',
  'termsOfService.section7.1.item1': 'Maintenance, mise à niveau ou défaillance du système',
  'termsOfService.section7.1.item2': 'Facteurs de force majeure (tels que catastrophes naturelles, guerres, grèves, etc.)',
  'termsOfService.section7.1.item3': 'Problèmes avec les fournisseurs de services tiers',
  'termsOfService.section7.1.item4': 'Pannes réseau ou problèmes d\'appareils utilisateurs',
  'termsOfService.section7.2.title': '7.2 Garantie du Service',
  'termsOfService.section7.2.content': 'Nous nous efforçons d\'assurer la stabilité et la disponibilité du service, mais nous ne garantissons pas que le service ne sera pas interrompu, sans erreur ou complètement sécurisé. Le service est fourni sur une base "tel quel" et "tel que disponible" sans aucune garantie expresse ou implicite.',
  'termsOfService.section8.title': 'VIII. Protection de la Vie Privée',
  'termsOfService.section8.content': 'Nous accordons une grande importance à la protection de votre vie privée. Pour plus d\'informations sur la façon dont nous collectons, utilisons et protégeons vos informations personnelles, veuillez consulter notre Politique de Confidentialité. L\'utilisation de ce service indique votre accord avec notre Politique de Confidentialité.',
  'termsOfService.section9.title': 'IX. Limitation de Responsabilité',
  'termsOfService.section9.1.title': '9.1 Portée de la Responsabilité',
  'termsOfService.section9.1.intro': 'Dans la mesure maximale permise par la loi, nous ne sommes pas responsables de tout dommage direct, indirect, fortuit, spécial ou consécutif résultant de l\'utilisation ou de l\'impossibilité d\'utiliser ce service, y compris mais sans s\'y limiter :',
  'termsOfService.section9.1.item1': 'Perte de profits, perte de données ou autres pertes économiques',
  'termsOfService.section9.1.item2': 'Interruption d\'activité',
  'termsOfService.section9.1.item3': 'Blessure corporelle ou perte de biens',
  'termsOfService.section9.1.item4': 'Violation de la vie privée',
  'termsOfService.section9.2.title': '9.2 Plafond de Responsabilité',
  'termsOfService.section9.2.content': 'Notre responsabilité totale ne dépasse pas le montant total que vous avez réellement payé pour ce service au cours des 12 derniers mois, ou 100 dollars américains (le montant le plus élevé).',
  'termsOfService.section10.title': 'X. Résiliation du Service',
  'termsOfService.section10.1.title': '10.1 Résiliation par l\'Utilisateur',
  'termsOfService.section10.1.content': 'Vous pouvez cesser d\'utiliser ce service et annuler votre compte à tout moment.',
  'termsOfService.section10.2.title': '10.2 Résiliation par la Plateforme',
  'termsOfService.section10.2.intro': 'Nous avons le droit de résilier ou de suspendre immédiatement votre compte et service dans les circonstances suivantes :',
  'termsOfService.section10.2.item1': 'Vous violez ces Conditions d\'Utilisation',
  'termsOfService.section10.2.item2': 'Vous vous livrez à des activités illégales',
  'termsOfService.section10.2.item3': 'Votre compte n\'a pas été utilisé pendant une longue période',
  'termsOfService.section10.2.item4': 'Exigences légales ou réglementaires',
  'termsOfService.section10.2.note': 'Après la résiliation du service, vous ne pourrez plus accéder à votre compte et au contenu généré, sauf disposition contraire de la loi.',
  'termsOfService.section11.title': 'XI. Résolution des Litiges',
  'termsOfService.section11.1.title': '11.1 Négociation',
  'termsOfService.section11.1.content': 'En cas de litige, les deux parties doivent d\'abord tenter de le résoudre par négociation amiable.',
  'termsOfService.section11.2.title': '11.2 Loi Applicable',
  'termsOfService.section11.2.content': 'Ces Conditions d\'Utilisation sont régies par les lois de la République populaire de Chine. Si les deux parties ne peuvent pas résoudre le litige par négociation, il sera soumis à un tribunal populaire compétent dans notre localité.',
  'termsOfService.section12.title': 'XII. Autres Dispositions',
  'termsOfService.section12.1.title': '12.1 Modification des Conditions',
  'termsOfService.section12.1.content': 'Nous nous réservons le droit de modifier ces Conditions d\'Utilisation à tout moment. Les modifications importantes vous seront notifiées au moins 30 jours avant leur entrée en vigueur. La poursuite de l\'utilisation du service indique votre acceptation des conditions modifiées.',
  'termsOfService.section12.2.title': '12.2 Divisibilité',
  'termsOfService.section12.2.content': 'Si une disposition de ces Conditions d\'Utilisation est jugée invalide ou inexécutable, cela n\'affecte pas la validité des autres dispositions.',
  'termsOfService.section12.3.title': '12.3 Accord Complet',
  'termsOfService.section12.3.content': 'Ces Conditions d\'Utilisation constituent l\'accord complet entre vous et nous concernant l\'utilisation de ce service, remplaçant tous les accords oraux ou écrits antérieurs.',
  'termsOfService.section13.title': 'XIII. Nous Contacter',
  'termsOfService.section13.intro': 'Si vous avez des questions concernant ces Conditions d\'Utilisation, veuillez nous contacter par les moyens suivants :',
  'termsOfService.section13.email': 'E-mail : {email}',
  'termsOfService.section13.hours': 'Heures de service client : jours ouvrables 9h00-18h00',
  
  // Footer
  'footer.brand.description': 'Fournit des services de génération avec IA.',
  'footer.joinUs': 'Rejoignez-nous',
  'footer.product.title': 'Produit',
  'footer.product.signup': 'S\'inscrire',
  'footer.product.login': 'Se connecter',
  'footer.product.workspace': 'Espace de travail',
  'footer.product.works': 'Mes œuvres',
  'footer.support.title': 'Support',
  'footer.support.help': 'Centre d\'aide',
  'footer.support.about': 'À propos de nous',
  'footer.support.feedback': 'Commentaires',
  'footer.support.contact': 'Nous contacter',
  'footer.legal.title': 'Légal',
  'footer.legal.privacy': 'Politique de confidentialité',
  'footer.legal.terms': 'Conditions d\'utilisation',
  'footer.legal.recharge': 'Accord de recharge',
  'footer.resources.title': 'Ressources',
  'footer.resources.invite': 'Inviter des amis',
  'footer.resources.account': 'Gestion de compte',
  'footer.resources.orders': 'Centre de commandes',
  'footer.copyright': '© {year} {brand}. Tous droits réservés.',
  'footer.description': 'Cette plateforme fournit des services de génération avec IA',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Base de données mondiale de robotique humanoïde avec comparaison de spécifications et informations sectorielles',
  'footer.openRobotX.visit': 'Visiter Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'Plateforme de génération complète avec IA pour créer divers contenus numériques',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Musique cloud personnelle : découverte, playlists, lecture et bibliothèque',
  
  // Page de tarification
  'pricing.title': 'Choisissez le plan qui vous convient',
  'pricing.plan.basic.sub': 'Basique',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Équipe',
  'pricing.plan.popular': 'POPULAIRE',
  'pricing.plan.button.select': 'Sélectionner ce plan',
  'pricing.plan.button.subscribe': 'S\'abonner maintenant',
  'pricing.plan.basic.videoQuota': '5/mois',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/mois',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/mois',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Quota de génération vidéo',
  'pricing.feature.videoDuration': 'Durée vidéo',
  'pricing.feature.videoQuality': 'Qualité vidéo',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Workflow',
  'pricing.feature.priorityQueue': 'File prioritaire',
  'pricing.feature.exclusiveChannel': 'Canal exclusif',
  'pricing.feature.highestQuality': 'Mode qualité maximale',
  'pricing.feature.sdImage': 'Génération d\'images SD',
  'pricing.feature.unlimited': 'Illimité',
  'pricing.feature.promptOptimization': 'Optimisation de prompt',
  'pricing.feature.imageSize': 'Taille d\'image',
  'pricing.feature.storage': 'Espace de stockage',
  'pricing.feature.commercialLicense': 'Licence commerciale',
  'pricing.feature.apiAccess': 'Accès API',
  'pricing.then': 'puis',
  'cta.title': 'Commencez à créer vos vidéos',
  'cta.description': 'Inscrivez-vous maintenant et transformez votre créativité en œuvres vidéo époustouflantes avec la technologie IA',
  'cta.button': 'Commencer gratuitement',
  'technology.coreArchitecture': 'ARCHITECTURE CORE',
  'technology.workflowEngine.title': 'Moteur de Workflow Visuel',
  'technology.workflowEngine.description': 'Support de workflow visuel à venir. Chaque nœud est un contrôle précis sur la créativité.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Moniteur de Ressources Système',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Exécuter le Workflow',
  'technology.button.running': 'Exécution...',
  'technology.log.systemInitialized': '> Système initialisé.',
  'technology.log.waitingForInput': '> En attente de saisie utilisateur...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Benchmark de Performance Ultime',
  'technology.benchmark.description': 'Pour cette amélioration de 0,5 seconde, nous avons réécrit 30% des opérateurs sous-jacents.',
  'technology.benchmark.fps.title': 'Vitesse de Génération (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'Optimisation VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'ÉCOLOGIE OUVERTE',
  'technology.galaxy.title': 'Univers Infini de Modèles',
  'technology.galaxy.description': 'Support de connexion directe Civitai, des milliers de modèles, chargement en un clic.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Page de commentaires
  'feedback.leftPanel.title.line1': 'Nous écoutons',
  'feedback.leftPanel.title.line2': 'Votre voix',
  'feedback.leftPanel.description': 'Vos commentaires sont la force motrice derrière l\'amélioration de notre produit. Que vous ayez trouvé un bug ou une idée brillante pour une nouvelle fonctionnalité, faites-le nous savoir.',
  'feedback.contact.helpDoc.title': 'Documentation d\'aide',
  'feedback.contact.helpDoc.desc': 'Consulter les FAQ et guides utilisateur',
  'feedback.contact.email.title': 'Support par e-mail',
  'feedback.contact.service.title': 'Support en ligne',
  'feedback.contact.service.hours': 'Jours ouvrables 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Suggestion de fonctionnalité',
  'feedback.type.suggestion.desc': 'J\'ai de nouvelles idées ou suggestions d\'amélioration',
  'feedback.type.bug.title': 'Rapport de bug',
  'feedback.type.bug.desc': 'J\'ai rencontré une erreur ou une exception',
  'feedback.type.question.title': 'Demande d\'utilisation',
  'feedback.type.question.desc': 'Je ne comprends pas comment utiliser une fonctionnalité',
  'feedback.type.other.title': 'Autre',
  'feedback.type.other.desc': 'Autres types de commentaires',
  'feedback.form.type.label': 'Type de commentaire',
  'feedback.form.title.label': 'Résumé bref',
  'feedback.form.title.placeholder': 'Décrivez votre problème ou suggestion en une phrase',
  'feedback.form.title.required': 'Veuillez entrer un titre',
  'feedback.form.content.label': 'Description détaillée',
  'feedback.form.content.placeholder': 'Veuillez décrire le contexte, les étapes de reproduction ou les suggestions spécifiques...',
  'feedback.form.content.required': 'Veuillez entrer un contenu détaillé',
  'feedback.form.attachment.label': 'Pièces jointes (Optionnel)',
  'feedback.upload.dragText': 'Cliquez ou faites glisser des fichiers ici pour télécharger',
  'feedback.upload.hint': 'Prend en charge les formats JPG, PNG, PDF et autres, taille de fichier unique ne dépassant pas 5MB',
  'feedback.upload.sizeLimit': 'La taille du fichier ne peut pas dépasser 5MB',
  'feedback.form.priority.label': 'Priorité',
  'feedback.priority.low.label': 'Faible',
  'feedback.priority.low.desc': 'N\'affecte pas l\'utilisation',
  'feedback.priority.medium.label': 'Moyenne',
  'feedback.priority.medium.desc': 'Affecte l\'expérience utilisateur',
  'feedback.priority.high.label': 'Élevée',
  'feedback.priority.high.desc': 'Entrave gravement l\'utilisation',
  'feedback.form.contact.label': 'Informations de contact (Optionnel)',
  'feedback.form.contact.placeholder': 'E-mail ou numéro de téléphone',
  'feedback.form.submit': 'Soumettre les commentaires',
  'feedback.submit.error': 'Échec de l\'envoi, veuillez réessayer plus tard',
  'feedback.success.title': 'Commentaires reçus !',
  'feedback.success.description': 'Merci pour vos précieux commentaires. Notre équipe produit lira attentivement chaque commentaire. S\'il s\'agit d\'un rapport de bug, nous pourrions vous contacter via les informations de contact fournies.',
  'feedback.success.back': 'Retour',
  'feedback.success.another': 'Soumettre un autre',
  // Page d'invitation
  'invite.partnerProgram': 'Programme Partenaire',
  'invite.title.line1': 'Invitez vos amis',
  'invite.title.line2': 'Créez une valeur illimitée',
  'invite.reward.inviter': 'Gagnez {amount} de récompense en espèces pour chaque ami invité.',
  'invite.reward.invitee': 'Votre ami reçoit {amount} de bonus de bienvenue à l\'inscription.',
  'invite.step1.title': '1. Partagez le lien',
  'invite.step1.desc': 'Partagez votre lien exclusif via les réseaux sociaux',
  'invite.step2.title': '2. L\'ami s\'active',
  'invite.step2.desc': 'L\'ami termine l\'inscription et la vérification',
  'invite.step3.title': '3. Retirez vos gains',
  'invite.step3.desc': 'Gains instantanés, retrait vers le solde',
  'invite.exclusiveCode': 'VOTRE CODE EXCLUSIF',
  'invite.copyCode': 'Copier le code',
  'invite.viewQrcode': 'Voir le QR Code',
  'invite.stats.totalInvites': 'Total invités',
  'invite.stats.availableReward': 'Solde disponible',
  'invite.stats.totalReward': 'Gains totaux',
  'invite.withdrawNow': 'Retirer maintenant',
  'invite.history.title': 'Historique des invitations',
  'invite.filter.all': 'Tous',
  'invite.filter.active': 'Actifs',
  'invite.filter.pending': 'En attente',
  'invite.status.credited': 'Crédité',
  'invite.status.pending': 'En attente',
  'invite.history.empty': 'Aucun enregistrement',
  'invite.withdraw.title': 'Retirer les gains',
  'invite.withdraw.cancel': 'Annuler',
  'invite.withdraw.confirm': 'Confirmer le retrait',
  'invite.withdraw.amount': 'Montant du retrait',
  'invite.withdraw.note': '* Le montant sera transféré directement sur votre solde de compte.',
  'invite.withdraw.enterAmount': 'Veuillez entrer le montant du retrait',
  'invite.withdraw.insufficientBalance': 'Solde insuffisant',
  'invite.withdraw.success': '¥{amount} retirés avec succès vers le solde',
  'invite.qrcode.title': 'Scanner pour rejoindre',
  'invite.copyLink': 'Copier le lien',
  'invite.copy.success': 'Copié avec succès',
  // Section Hero de la page d'accueil
  'home.hero.badge': 'Assistant IA · Compagnon · Partenaire',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Votre Camarade de Classe, Âme Sœur, Coéquipier',
  'home.hero.description': 'AIMATEX est votre assistant IA, partenaire d\'apprentissage et compagnon créatif. Nous fournissons des solutions IA complètes, faisant de l\'IA votre meilleur partenaire dans le travail, l\'étude et la création. Que ce soit l\'apprentissage en classe, la collaboration créative ou la coopération d\'équipe, AIMATEX est votre partenaire de confiance.',
  'home.hero.cta.signup': 'Commencer gratuitement',
  'home.hero.cta.login': 'Se connecter',
  'home.hero.cta.workspace': 'Accéder à l\'espace de travail',
  // Section des produits de la page d'accueil
  'home.products.title': 'Nos Produits',
  'home.products.subtitle': 'Explorez les produits IA innovants d\'AIMATEX, chaque produit est votre meilleur partenaire dans différents scénarios',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'Partenaire de création image-à-vidéo IA, transformant les images statiques en vidéos dynamiques, donnant vie à votre créativité',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'Plateforme de génération et conversion d\'objets 3D alimentée par l\'IA, votre partenaire de création 3D',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Explorez les entreprises mondiales de robots humanoïdes, les comparaisons de paramètres et les informations de l\'industrie, votre partenaire de recherche en robotique',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Plateforme d\'agents autonomes — créez et déployez des agents intelligents avec OpenForgeX.',
  'home.products.openclaw4j.cta': 'Essayer l\'agent',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Espace musique cloud personnel — découvrir des titres, playlists collaboratives, lecture en cours et bibliothèque cloud',
  'home.products.aimatexMusic.cta': 'Entrer dans la musique',
  'home.music.eyebrow': 'Suite AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Votre espace musique cloud — découvrir, collectionner et écouter ensemble.',
  'home.music.feature.discover.title': 'Découvrir',
  'home.music.feature.discover.desc': 'Rechercher et importer des titres dans votre bibliothèque.',
  'home.music.feature.playlist.title': 'Playlists',
  'home.music.feature.playlist.desc': 'Créer et partager des playlists collaboratives.',
  'home.music.feature.nowPlaying.title': 'En écoute',
  'home.music.feature.nowPlaying.desc': 'Écoute synchronisée, favoris et historique.',
  'home.music.feature.cloud.title': 'Bibliothèque cloud',
  'home.music.feature.cloud.desc': 'Audio haute qualité stocké en toute sécurité.',
  'home.music.cta': 'Ouvrir AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'En savoir plus',
  // Section des fonctionnalités de la page d'accueil
  'home.features.title': 'Atelier créatif tout-en-un.',
  'home.features.subtitle': 'Plus qu\'une simple génération de vidéos, c\'est une autonomisation créative complète.',
  'home.features.aiPrompt.title': 'Vous ne pouvez pas écrire de prompts ? L\'IA écrit pour vous',
  'home.features.aiPrompt.description': 'Complètement à court d\'idées ? Laissez l\'IA écrire pour vous en un clic. Tapez simplement quelques mots, l\'IA les peaufine automatiquement en descriptions cinématographiques, 10 secondes pour générer. Vous voulez changer de style ? Cliquez à nouveau, transformez instantanément en cyberpunk/peinture à l\'huile/anime.',
  'home.features.demo.userInput': 'un chat',
  'home.features.demo.aiResult': 'Un chat persan élégant avec une fourrure longue et duveteuse blanche, des yeux ambrés, assis sur un rebord de fenêtre ensoleillé. L\'arrière-plan présente un ciel bleu clair et des rideaux blancs flottants. 4K ultra HD, éclairage cinématographique, profondeur de champ, photographie professionnelle.',
  'home.features.demo.buttonText': 'Générer IA',
  'home.features.demo.buttonLoading': 'Génération',
  'home.features.demo.thinkingText': 'L\'IA crée✨',
  'home.features.quality.title': 'Qualité cinématographique',
  'home.features.quality.description': 'Prise en charge native de la sortie en résolution 4K, chaque image est délicatement conçue.',
  'home.features.imageToVideo.title': 'Image en vidéo',
  'home.features.imageToVideo.description': 'Téléchargez une image statique, l\'IA comprend l\'éclairage et la physique dans la scène, génère automatiquement des dynamiques ultérieures, donnant vie aux photos.',
  'home.features.multimodal.title': 'Écosystème multimodal',
  'home.features.multimodal.description': 'Non seulement prend en charge la génération d\'images à partir de texte de Stable Diffusion, mais intègre également le transfert de style de Midjourney et la synthèse audio d\'ElevenLabs. Complétez toutes les créations dans un flux de travail.',
  
  // Section communauté de la page d'accueil
  'home.community.title': 'Explorez les communautés créatives IA',
  'home.community.subtitle': 'Rejoignez des millions de créateurs, partagez vos chefs-d\'œuvre IA et obtenez inspiration et commentaires',
  'home.community.hot': 'Populaire',
  'home.community.explore': 'Explorer la communauté',
  'home.community.stats.works': 'Œuvres',
  'home.community.stats.creators': 'Créateurs',
  'home.community.stats.views': 'Vues',
  'home.community.image.title': 'Communauté d\'images IA',
  'home.community.image.description': 'Découvrez et partagez de superbes images générées par IA, du photoréalisme à l\'art, des illustrations à la photographie',
  'home.community.video.title': 'Communauté de vidéos IA',
  'home.community.video.description': 'Explorez d\'incroyables vidéos générées par IA, apprenez des techniques créatives et échangez avec des créateurs de vidéos du monde entier',
  'home.community.music.title': 'Communauté de musique IA',
  'home.community.music.description': 'Écoutez de belles mélodies composées par IA, partagez vos œuvres musicales et trouvez des passionnés de musique partageant les mêmes idées',
  'home.community.3d.title': 'Communauté de modèles 3D IA',
  'home.community.3d.description': 'Explorez le monde des modèles 3D générés par IA, de l\'architecture aux personnages, des jeux au design industriel',
  'home.community.voice.title': 'Communauté de voix IA',
  'home.community.voice.description': 'Découvrez la synthèse vocale IA réaliste, doublage, livres audio, clonage vocal et donnez vie à vos créations',
  'home.community.text.title': 'Communauté de texte IA',
  'home.community.text.description': 'Partagez d\'excellents textes créés par IA, romans, poèmes, scénarios, textes publicitaires et inspirez votre créativité littéraire',
  
  // Page de facturation
  'billing.page.title': 'Centre financier',
  'billing.page.description': 'Gérez vos transactions et détails de facturation',
  'billing.button.refresh': 'Actualiser',
  'billing.button.recharge': 'Recharger',
  'billing.button.reset': 'Réinitialiser',
  'billing.button.apply': 'Appliquer les filtres',
  'billing.balance.cny': 'Solde CNY',
  'billing.balance.usdt': 'Solde USDT',
  'billing.balance.usd': 'Solde USD',
  'billing.balance.token': 'Solde de jetons',
  'billing.balance.frozen': 'Gelé',
  'billing.type.frozen': 'Fonds gelés',
  'billing.type.aiModelFee': 'Frais de modèle IA',
  'billing.type.recharge': 'Recharge',
  'billing.type.refund': 'Remboursement',
  'billing.type.reward': 'Récompense',
  'billing.type.all': 'Tous les types',
  'billing.coin.all': 'Toutes les devises',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Type',
  'billing.table.coinType': 'Devise',
  'billing.table.time': 'Heure',
  'billing.table.amount': 'Montant',
  'billing.table.remark': 'Remarque',
  'billing.table.balance': 'Solde',
  'billing.table.empty': 'Aucun enregistrement',
  'billing.filter.title': 'Options de filtre',
  'billing.filter.button': 'Filtrer et date',
  'billing.filter.changeType': 'Type de transaction',
  'billing.filter.coinType': 'Type de devise',
  'billing.filter.remark': 'Recherche de remarque',
  'billing.filter.remarkPlaceholder': 'Entrez les mots-clés',
  'billing.filter.remarkSearch': 'Recherche de remarque',
  'billing.filter.dateQuick': 'Date rapide',
  'billing.filter.dateCustom': 'Date personnalisée',
  'billing.filter.dateTo': 'à',
  'billing.filter.days7': '7 derniers jours',
  'billing.filter.days30': '30 derniers jours',
  'billing.filter.days90': '3 derniers mois',
  'billing.placeholder.changeType': 'Type de changement',
  'billing.placeholder.coinType': 'Devise',
  'billing.placeholder.remark': 'Recherche de remarque',
  'billing.message.fetchBalanceError': 'Échec de la récupération du solde',
  'billing.message.fetchRecordsError': 'Échec de la récupération des enregistrements',
  'billing.message.tryAgain': 'Échec de la récupération des enregistrements, veuillez réessayer plus tard',
  
  // Page de recharge
  'recharge.page.title': 'Recharge du compte',
  'recharge.page.backLink': 'Retour à la facturation',
  'recharge.balance.title': 'Solde du compte',
  'recharge.balance.refresh': 'Actualiser',
  'recharge.section.coinType': 'Devise de recharge',
  'recharge.section.paymentMethod': 'Moyen de paiement',
  'recharge.section.amount': 'Montant de recharge',
  'recharge.order.title': 'Détails de la commande',
  'recharge.order.type': 'Type de recharge',
  'recharge.order.typeValue': 'Recharge du solde du compte',
  'recharge.order.account': 'Compte',
  'recharge.order.accountLoading': 'Chargement...',
  'recharge.order.paymentMethod': 'Moyen de paiement',
  'recharge.order.paymentMethodPlease': 'Veuillez sélectionner',
  'recharge.order.total': 'Montant total',
  'recharge.button.pay': 'Payer maintenant',
  'recharge.button.customize': 'Montant personnalisé',
  'recharge.placeholder.customAmount': 'Entrez un montant personnalisé',
  'recharge.security.ssl': 'Transmission cryptée SSL, paiement sécurisé',
  'recharge.security.agreement': 'En cliquant sur Payer, vous acceptez',
  'recharge.security.agreementLink': 'Accord de service de recharge',
  'recharge.empty.noCurrency': 'Aucune devise supportée',
  'recharge.empty.noPaymentMethod': 'Aucun moyen de paiement disponible pour {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Veuillez d\'abord sélectionner la devise',
  'recharge.empty.pleaseSelectPayment': 'Veuillez d\'abord sélectionner le moyen de paiement',
  'recharge.empty.noProducts': 'Aucun produit disponible',
  'recharge.empty.noPresets': 'Aucun montant prédéfini pour {currency}',
  'recharge.message.invalidAmount': 'Veuillez entrer un montant valide',
  'recharge.message.selectPaymentMethod': 'Veuillez sélectionner un moyen de paiement',
  'recharge.message.selectAmount': 'Veuillez sélectionner le montant de recharge',
  'recharge.message.fetchBalanceError': 'Échec de la récupération du solde, veuillez réessayer plus tard',
  'recharge.message.fetchUserInfoError': 'Échec de la récupération des informations utilisateur',
  'recharge.message.fetchCurrenciesError': 'Échec de la récupération des devises, veuillez réessayer plus tard',
  'recharge.message.fetchPaymentMethodsError': 'Échec de la récupération des moyens de paiement, veuillez réessayer plus tard',
  'recharge.message.fetchCreemProductsError': 'Échec de la récupération des produits Creem, veuillez réessayer plus tard',
  'recharge.message.fetchCreemProductsWarning': 'Échec de la récupération des produits Creem',
  'recharge.message.orderCreated': 'Commande créée avec succès',
  'recharge.message.orderCreateFailed': 'Échec de la création de la commande de recharge',
  'recharge.message.paymentProcessing': 'Ouverture de la page de paiement, veuillez compléter le paiement...',
  'recharge.message.popupBlocked': 'Impossible d\'ouvrir la fenêtre de paiement, veuillez vérifier les paramètres de popup du navigateur',
  'recharge.message.paymentUrlError': 'Échec de l\'obtention de l\'URL de paiement',
  'recharge.message.checkoutSessionError': 'Échec de la création de la session de paiement',
  'recharge.message.paymentError': 'Échec du traitement du paiement, veuillez réessayer plus tard',
  'recharge.message.redirecting': 'Redirection vers la page de paiement, veuillez compléter le paiement...',
  'recharge.message.paymentUrlFailed': 'URL de paiement non disponible',
  'recharge.message.paymentSuccess': 'Paiement réussi! Solde mis à jour',
  'recharge.message.orderCancelled': 'Commande annulée',
  'recharge.message.paymentFailed': 'Paiement échoué',
  'recharge.message.orderExpired': 'Expiré',
  'recharge.message.queryOrderError': 'Échec de la requête du statut de la commande',
  'recharge.message.rechargeError': 'Échec de la demande de recharge, veuillez réessayer plus tard',

  // Page des commandes
  'orders.title': 'Historique des commandes',
  'orders.subtitle': 'Consultez tous vos enregistrements de commandes de recharge et leurs statuts',
  'orders.refresh': 'Actualiser',
  'orders.goToRecharge': 'Recharger',

  // Cartes statistiques
  'orders.stats.totalOrders': 'Total des commandes',
  'orders.stats.pending': 'En attente',
  'orders.stats.paid': 'Payé',
  'orders.stats.totalAmount': 'Montant total rechargé',

  // Colonnes du tableau
  'orders.table.orderNo': 'N° de commande',
  'orders.table.createTime': 'Créé le',
  'orders.table.amount': 'Montant',
  'orders.table.paymentMethod': 'Méthode de paiement',
  'orders.table.status': 'Statut',
  'orders.table.action': 'Action',
  'orders.table.view': 'Voir',
  'orders.table.cancel': 'Annuler',
  'orders.table.empty': 'Aucun enregistrement de commande',

  // Statut de la commande
  'orders.status.pending': 'En attente',
  'orders.status.paid': 'Payé',
  'orders.status.success': 'Terminé',
  'orders.status.cancelled': 'Annulé',
  'orders.status.failed': 'Échoué',
  'orders.status.expired': 'Expiré',
  'orders.status.all': 'Tous les statuts',

  // Méthodes de paiement
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Carte bancaire',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Toutes les méthodes',

  // Devise
  'orders.coin.all': 'Toutes les devises',

  // Filtres
  'orders.filter.title': 'Options de filtrage',
  'orders.filter.button': 'Filtrer les commandes',
  'orders.filter.reset': 'Réinitialiser',
  'orders.filter.apply': 'Appliquer',
  'orders.filter.orderStatus': 'Statut de la commande',
  'orders.filter.paymentMethod': 'Méthode de paiement',
  'orders.filter.coinType': 'Type de devise',
  'orders.filter.orderNoSearch': 'Rechercher par N° de commande',
  'orders.filter.quickDate': 'Date rapide',
  'orders.filter.customDate': 'Date personnalisée',
  'orders.filter.dateTo': 'à',
  'orders.filter.last7Days': '7 derniers jours',
  'orders.filter.last30Days': '30 derniers jours',
  'orders.filter.last3Months': '3 derniers mois',

  // Recherche et saisie
  'orders.search.placeholder': 'Rechercher le numéro de commande',
  'orders.input.orderNo': 'Entrer le numéro de commande',
  'orders.select.orderStatus': 'Statut de la commande',
  'orders.select.paymentMethod': 'Méthode de paiement',
  'orders.select.coinType': 'Devise',

  // Messages
  'orders.message.fetchError': 'Échec de la récupération des commandes',
  'orders.message.fetchErrorRetry': 'Échec de la récupération des commandes, veuillez réessayer plus tard',
  'orders.message.statsError': 'Échec de la récupération des statistiques',
  'orders.message.cancelSuccess': 'Commande annulée',
  'orders.message.cancelError': 'Échec de l\'annulation de la commande',
  'orders.message.cancelErrorRetry': 'Échec de l\'annulation de la commande, veuillez réessayer plus tard',
  'orders.message.viewOrder': 'N° de commande : {orderNo}',

  // Dialogue de confirmation
  'orders.confirm.cancel': 'Êtes-vous sûr de vouloir annuler cette commande ?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Annuler',

  // Page Rejoignez-nous
  'joinUs.seo.title': 'Rejoindre PROTX - La quête de l\'excellence',
  'joinUs.seo.description': 'Rejoignez l\'équipe PROTX et poursuivez l\'expérience utilisateur et le design produit ultimes avec nous',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Quête de l\'excellence',
  'joinUs.hero.title2': 'Définir l\'avenir par le design',
  'joinUs.hero.subtitle': 'PROTX est une équipe dédiée à créer l\'expérience utilisateur et le design produit ultimes. Nous croyons que chaque pixel compte, que chaque interaction mérite d\'être soigneusement peaufinée. Si vous partagez notre quête inlassable de l\'excellence, rejoignez-nous.',
  'joinUs.hero.cta': 'Voir les postes ouverts',
  'joinUs.hero.video': 'Voir notre histoire',
  
  'joinUs.values.eyebrow': 'NOS VALEURS',
  'joinUs.values.title': 'Nos valeurs fondamentales',
  'joinUs.values.subtitle': 'Ces valeurs fondamentales définissent qui nous sommes et comment nous travaillons ensemble',
  'joinUs.values.innovation.title': 'Innovation',
  'joinUs.values.innovation.desc': 'Nous croyons que l\'innovation est la force qui change le monde, encourageant chaque idée révolutionnaire.',
  'joinUs.values.collaboration.title': 'Collaboration',
  'joinUs.values.collaboration.desc': 'Collaboration inter-équipes pour créer ensemble des résultats extraordinaires.',
  'joinUs.values.excellence.title': 'Excellence',
  'joinUs.values.excellence.desc': 'Repousser constamment les limites pour l\'expérience ultime.',
  'joinUs.values.passion.title': 'Passion et Focus',
  'joinUs.values.passion.desc': 'Passion pour la technologie, dévouement au produit.',
  'joinUs.values.impact.title': 'Impact',
  'joinUs.values.impact.desc': 'Permettre l\'expression créative de chacun grâce à la technologie IA.',
  
  'joinUs.positions.eyebrow': 'POSTES OUVERTS',
  'joinUs.positions.title': 'Postes ouverts',
  'joinUs.positions.subtitle': 'Trouvez le rôle qui vous convient et commencez votre nouvelle aventure professionnelle',
  'joinUs.category.engineering': 'Ingénierie',
  'joinUs.category.product': 'Produit et Design',
  'joinUs.category.operations': 'Opérations et Marketing',
  'joinUs.position.seniorFrontend': 'Ingénieur Frontend Senior',
  'joinUs.position.backendEngineer': 'Ingénieur Backend',
  'joinUs.position.mlEngineer': 'Ingénieur IA/ML',
  'joinUs.position.productManager': 'Chef de Produit',
  'joinUs.position.uxDesigner': 'Designer UX',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Créateur de Contenu',
  'joinUs.location.remote': 'Télétravail',
  'joinUs.location.beijing': 'Pékin',
  'joinUs.location.shanghai': 'Shanghai',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Temps plein',
  'joinUs.type.parttime': 'Temps partiel',
  
  'joinUs.benefits.eyebrow': 'AVANTAGES',
  'joinUs.benefits.title': 'Ce que nous offrons',
  'joinUs.benefits.subtitle': 'Rejoignez-nous et profitez d\'avantages complets et d\'un soutien',
  'joinUs.benefit.flexible.title': 'Travail flexible',
  'joinUs.benefit.flexible.desc': 'Horaires flexibles et options de télétravail',
  'joinUs.benefit.equity.title': 'Stock-options',
  'joinUs.benefit.equity.desc': 'Grandissez avec l\'entreprise et partagez notre succès',
  'joinUs.benefit.health.title': 'Couverture santé',
  'joinUs.benefit.health.desc': 'Assurance santé complète et avantages bien-être',
  'joinUs.benefit.growth.title': 'Évolution de carrière',
  'joinUs.benefit.growth.desc': 'Opportunités d\'apprentissage et de développement continus',
  
  'joinUs.cta.title': 'Prêt à commencer ?',
  'joinUs.cta.subtitle': 'Si vous êtes passionné par notre mission, nous avons hâte de vous entendre',
  'joinUs.cta.button': 'Postuler maintenant',
  
  'joinUs.modal.title': 'Candidature',
  'joinUs.apply.success': 'Candidature envoyée ! Nous vous contacterons bientôt.',
  'joinUs.form.name': 'Nom',
  'joinUs.form.name.required': 'Veuillez entrer votre nom',
  'joinUs.form.name.placeholder': 'Entrez votre nom',
  'joinUs.form.email': 'Email',
  'joinUs.form.email.required': 'Veuillez entrer votre email',
  'joinUs.form.email.invalid': 'Veuillez entrer une adresse email valide',
  'joinUs.form.email.placeholder': 'Entrez votre email',
  'joinUs.form.phone': 'Téléphone',
  'joinUs.form.phone.placeholder': 'Entrez votre numéro de téléphone',
  'joinUs.form.experience': 'Expérience',
  'joinUs.form.experience.placeholder': 'Sélectionnez votre niveau d\'expérience',
  'joinUs.form.experience.0-2': '0-2 ans',
  'joinUs.form.experience.3-5': '3-5 ans',
  'joinUs.form.experience.5-10': '5-10 ans',
  'joinUs.form.experience.10+': '10+ ans',
  'joinUs.form.resume': 'CV',
  'joinUs.form.resume.hint': 'Cliquez ou glissez le fichier pour télécharger',
  'joinUs.form.resume.format': 'Formats PDF, DOC, DOCX acceptés',
  'joinUs.form.message': 'Lettre de motivation',
  'joinUs.form.message.placeholder': 'Parlez-nous de vous et pourquoi vous souhaitez nous rejoindre',
  'joinUs.form.submit': 'Envoyer la candidature',
  'joinUs.form.loginTip': 'Connectez-vous avant de postuler pour suivre votre candidature',
  'joinUs.form.goLogin': 'Se connecter',
  'joinUs.form.resume.sizeLimit': 'La taille du fichier ne peut pas dépasser 10 Mo',
  
  // Mes candidatures
  'joinUs.myApplications.eyebrow': 'MES CANDIDATURES',
  'joinUs.myApplications.title': 'Historique des candidatures',
  'joinUs.myApplications.empty': 'Pas encore de candidature. Soumettez votre CV maintenant !',
  'joinUs.myApplications.viewDetail': 'Voir les détails',
  'joinUs.myApplications.detailTitle': 'Détails de la candidature',
  'joinUs.status.pending': 'En attente',
  'joinUs.status.reviewing': 'En cours d\'examen',
  'joinUs.status.interview': 'Entretien',
  'joinUs.status.accepted': 'Accepté',
  'joinUs.status.rejected': 'Refusé',
  'joinUs.detail.basicInfo': 'Informations de base',
  'joinUs.detail.positionInfo': 'Informations sur le poste',
  'joinUs.detail.position': 'Poste demandé',
  'joinUs.detail.category': 'Catégorie',
  'joinUs.detail.location': 'Lieu',
  'joinUs.detail.applyTime': 'Date de candidature',
  'joinUs.detail.downloadResume': 'Télécharger le CV',
  'joinUs.detail.status': 'Statut de la candidature',

  // Page About
  'about.hero.title1': 'Noyau Open Source.',
  'about.hero.title2': 'Possibilités infinies.',
  'about.hero.subtitle1': 'Basé sur',
  'about.hero.subtitle2': 'et',
  'about.hero.subtitle3': 'écosystème.',
  'about.hero.description': 'Nous intégrons la pile technologique IA générative de pointe de 2025 dans une expérience interactive ultime.',
  'about.tech.poweredBy': 'Propulsé par',
  'about.philosophy.title1': 'Plus que de la génération.',
  'about.philosophy.title2': 'C\'est un processus complet',
  'about.philosophy.title3': 'moteur de créativité.',
  'about.philosophy.description': 'Du contrôle précis du texte-à-image à la simulation physique de la génération vidéo, nous repoussons les limites de la technologie.',
  'about.bento.comfy.title': 'Contrôle précis au niveau des nœuds.',
  'about.bento.comfy.description': 'Basé sur l\'architecture de nœuds ComfyUI, prenant en charge le contrôle de pose ControlNet et le transfert de style IP-Adapter. Nous encapsulons une logique de nœuds complexe en curseurs intuitifs, rendant chaque génération exactement comme vous l\'imaginez.',
  'about.bento.opensource.title': 'Embrasser l\'open source.',
  'about.bento.opensource.description': 'Basé sur Stable Diffusion 3.5 & XL Turbo. Non seulement une génération ultra-rapide, mais aussi un support massif de modèles LoRA de la communauté.',
  'about.bento.video.title': 'Architecture vidéo DiT.',
  'about.bento.video.description': 'Introduction du Diffusion Transformer (DiT) avec mécanisme d\'attention spatio-temporelle, atteignant une simulation du monde physique de niveau SORA.',
  'about.bento.audio.title': 'Synchronisation audio-visuelle, éveil sensoriel.',
  'about.bento.audio.description': 'Au-delà du visuel. Intégré aux derniers modèles de génération audio, prenant en charge le Text-to-Audio et l\'alignement vidéo automatique. De la vue au son, construisant une expérience immersive complète.',
  'about.techSection.title': 'Architecture technique.',
  'about.techSection.description': 'Plongez dans le moteur central qui alimente ProductX.',
  'about.techCard.sd.title': 'La fondation de l\'art génératif.',
  'about.techCard.sd.description': 'Nous intégrons profondément les derniers modèles de génération Stable Diffusion. Grâce à un VAE personnalisé et des échantillonneurs optimisés, nous atteignons une génération 300% plus rapide tout en maintenant une qualité d\'image exquise.',
  'about.techCard.spec.baseModel': 'Modèle de base',
  'about.techCard.spec.resolution': 'Résolution',
  'about.techCard.spec.resolution.value': 'Jusqu\'à 4K Upscaling',
  'about.techCard.spec.control': 'Contrôle',
  'about.techCard.spec.speed': 'Vitesse',
  'about.techCard.spec.speed.value': '< 1s (Mode Turbo)',
  'about.techCard.video.title': 'Moteur physique vidéo nouvelle génération.',
  'about.techCard.video.description': 'Abandonnant la logique d\'animation 2D traditionnelle, adoptant la dernière architecture DiT (Diffusion Transformer) de 2025. Le modèle comprend l\'éclairage, la gravité et la physique du mouvement, générant non pas de simples vidéos, mais des mondes dynamiques physiquement précis.',
  'about.techCard.spec.architecture': 'Architecture',
  'about.techCard.spec.frameRate': 'Fréquence d\'images',
  'about.techCard.spec.frameRate.value': 'Interpolation 24 / 60 FPS',
  'about.techCard.spec.consistency': 'Cohérence',
  'about.techCard.spec.consistency.value': 'Haute stabilité temporelle',
  'about.techCard.spec.length': 'Durée',
  'about.techCard.spec.length.value': 'Extension en boucle infinie',
  'about.techCard.img2img.title': 'Image-à-image & transfert de style.',
  'about.techCard.img2img.description': 'En utilisant les technologies IP-Adapter et T2I-Adapter, nous réalisons un transfert de style zero-shot. Téléchargez une image de référence pour répliquer instantanément sa composition, son éclairage et son style artistique, libérant des possibilités créatives infinies.',
  'about.techCard.spec.technology': 'Technologie',
  'about.techCard.spec.precision': 'Précision',
  'about.techCard.spec.precision.value': 'Inpainting pixel-parfait',
  'about.cta.title': 'Prêt à expérimenter le futur ?',
  'about.cta.description': 'Rejoignez les rangs des créateurs professionnels et libérez le potentiel ultime de l\'IA.',
  'about.cta.button.start': 'Commencer',
  'about.cta.button.docs': 'Lire la documentation',
  
  // Community
  'community.explore.title': 'Explorer les communautés',
  'community.explore.subtitle': 'Découvrez l\'inspiration, remixez les workflows et connectez-vous avec des milliers de créateurs IA.',
  'community.posts': '{count} publications',
  'community.empty': 'Aucun canal communautaire',
  'community.loadFailed': 'Échec du chargement',
  'community.noPosts': 'Aucune publication pour le moment',
  'community.challenge.loadFailed': 'Échec du chargement des données du défi',
  
  'common.loadFailed': 'Échec du chargement',
  'common.operationFailed': 'Opération échouée',
  'common.error': 'Opération échouée',
  'common.publish': 'Publier',
  'common.back': 'Retour',
  'common.backToCommunity': 'Retour à la communauté',
  'common.copy': 'Copier',
  'common.copied': 'Copié',
  'common.follow': 'Suivre',
  'common.processing': 'Traitement...',
  'common.viewCount': '{count} vues',
  'common.loadMore': 'Charger plus',
  'common.search': 'Rechercher...',
  'common.notFound': 'Introuvable',
  'common.description': 'Description',
  
  'user.followSuccess': 'Suivi avec succès',
  'user.unfollowSuccess': 'Désabonnement réussi',
  'user.following': 'Suivi',
  'user.mutual_follow': 'Mutuel',
  
  'post.untitled': 'Création sans titre',
  'post.prompt': 'Invite',
  'post.negativePrompt': 'Invite négative',
  'post.details': 'Détails',
  'post.model': 'Modèle',
  'post.resolution': 'Résolution',
  'post.steps': 'Étapes',
  'post.cfgScale': 'Échelle de guidage',
  'post.remix': 'Remix / Essayer ceci',
  
  'challenge.status.upcoming': 'À venir',
  'challenge.status.live': 'En cours',
  'challenge.status.voting': 'Vote',
  'challenge.status.ended': 'Terminé',
  'challenge.status.unknown': 'Inconnu',
  'challenge.allChallenges': 'Tous les défis',
  'challenge.entriesCount': '{count} participations',
  'challenge.tab.submissions': 'Participations',
  'challenge.tab.rules': 'Règles et infos',
  'challenge.requirements': 'Exigences',
  'challenge.req.original': 'Créations originales uniquement.',
  'challenge.req.model': 'Doit utiliser le modèle : {model}',
  'challenge.req.tags': 'Doit inclure les tags :',
  'challenge.req.resolution': 'La résolution doit être d\'au moins 1024x1024.',
  'challenge.req.nsfw': 'Pas de contenu NSFW.',
  'challenge.timeRemaining': 'Temps restant',
  'challenge.startsIn': 'Démarre dans',
  'challenge.notStarted': 'Défi pas encore commencé',
  'challenge.closed': 'Défi fermé',
  'challenge.submitEntry': 'Soumettre une participation',
  'challenge.viewWinners': 'Voir les gagnants',
  'challenge.readRulesTip': 'Lisez les règles avant de soumettre',
  'challenge.prizePool': 'Cagnotte',
  'challenge.totalValue': 'Valeur totale',
  'challenge.rank.1st': '1ère place',
  'challenge.rank.2nd': '2ème place',
  'challenge.rank.3rd': '3ème place',
  'challenge.share': 'Partager le défi',
  'challenge.noEntries': 'Aucune participation pour le moment. Soyez le premier !',
  'challenge.noChallenges': 'Aucun défi trouvé',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Compression d\'image',
  'mediaTools.tab.videoCompress': 'Compression vidéo',
  'mediaTools.tab.audioCompress': 'Compression audio',
  'mediaTools.tab.formatConvert': 'Conversion de format',
  // ImageCompress
  'imageCompress.title': 'Outil de compression d\'images professionnel',
  'imageCompress.subtitle': 'Compression intelligente, qualité professionnelle',
  'imageCompress.upload': 'Télécharger des images',
  'imageCompress.addImages': 'Ajouter des images',
  'imageCompress.uploadToStart': 'Téléchargez des images pour commencer la compression',
  'imageCompress.settings': 'Paramètres',
  'imageCompress.clearAll': 'Tout effacer',
  'imageCompress.totalSavings': 'Espace économisé',
  'imageCompress.totalSize': 'Taille totale',
  'imageCompress.quality': 'Qualité',
  'imageCompress.resize': 'Redimensionner',
  'imageCompress.scalePercent': 'Échelle %',
  'imageCompress.customPx': 'Px personnalisé',
  'imageCompress.presetSize': 'Taille prédéfinie',
  'imageCompress.width': 'Largeur',
  'imageCompress.height': 'Hauteur',
  'imageCompress.format': 'Format',
  'imageCompress.format.auto': 'Auto (original)',
  'imageCompress.format.jpeg': 'JPEG (photo)',
  'imageCompress.format.png': 'PNG (sans perte)',
  'imageCompress.format.webp': 'WebP (meilleur)',
  'imageCompress.pngLossless': 'PNG est sans perte. Le curseur de qualité est masqué.',
  'imageCompress.cacheSettings': 'Paramètres du cache',
  'imageCompress.cacheTooltip': 'Lorsqu\'il est activé, les images téléchargées seront enregistrées dans le cache du navigateur et restaurées après le rechargement de la page.',
  'imageCompress.saveToCache': 'Enregistrer les images dans le cache du navigateur',
  'imageCompress.batchProcessing': 'Traitement par lots',
  'imageCompress.batchTooltip': 'Lorsqu\'il est activé, la compression sera appliquée à toutes les {count} images avec les paramètres actuels.',
  'imageCompress.applyToAll': 'Appliquer les paramètres à toutes les images ({count})',
  'imageCompress.compress': 'Appliquer et compresser',
  'imageCompress.compressAll': 'Appliquer et compresser tout ({count})',
  'imageCompress.compressing': 'Compression en cours...',
  'imageCompress.compressAllProgress': 'Compression de {count} images...',
  'imageCompress.download': 'Télécharger l\'image',
  'imageCompress.downloadAll': 'Tout télécharger ({count})',
  'imageCompress.downloadAllCheckbox': 'Télécharger toutes les {count} images',
  'imageCompress.original': 'Original',
  'imageCompress.compressed': 'Compressé',
  // Messages
  'imageCompress.message.compressed': 'Compression réussie !',
  'imageCompress.message.larger': 'Le fichier de sortie est plus volumineux. Essayez de réduire la qualité.',
  'imageCompress.message.failed': 'Échec de la compression',
  'imageCompress.message.batchSuccess': '{success} image(s) compressée(s) avec succès{failed}',
  'imageCompress.message.batchFailed': 'Toutes les compressions ont échoué',
  'imageCompress.message.noImagesToDownload': 'Aucune image compressée à télécharger',
  'imageCompress.message.downloading': 'Téléchargement de {count} image(s)...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Publication Instagram (1:1)',
  'imageCompress.preset.square': 'Carré (1:1)',
  'imageCompress.preset.facebookCover': 'Couverture Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'En-tête Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'Miniature YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'Publication Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'Story Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Paysage 16:9',
  'imageCompress.preset.classic4:3': 'Classique 4:3',
  'imageCompress.preset.photo3:2': 'Photo 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ultra-large 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Portrait (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Paysage (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Portrait (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Outil de compression audio professionnel',
  'audioCompress.subtitle': 'Compression basée sur le navigateur, confidentialité protégée',
  'audioCompress.upload': 'Télécharger audio',
  'audioCompress.uploadNew': 'Cliquez pour télécharger un nouvel audio',
  'audioCompress.uploadToStart': 'Téléchargez de l\'audio pour commencer la compression',
  'audioCompress.settings': 'Paramètres',
  'audioCompress.clearAll': 'Tout effacer',
  'audioCompress.totalSavings': 'Espace économisé',
  'audioCompress.totalSize': 'Taille totale',
  'audioCompress.audioInfo': 'Info audio',
  'audioCompress.quality': 'Qualité',
  'audioCompress.bitrate': 'Débit binaire',
  'audioCompress.bitrate.320': '320 kbps (Qualité maximale)',
  'audioCompress.bitrate.256': '256 kbps (Haute qualité)',
  'audioCompress.bitrate.192': '192 kbps (Qualité standard)',
  'audioCompress.bitrate.128': '128 kbps (Qualité moyenne)',
  'audioCompress.bitrate.96': '96 kbps (Basse qualité)',
  'audioCompress.bitrate.64': '64 kbps (Qualité minimale)',
  'audioCompress.format': 'Format',
  'audioCompress.format.mp3': 'MP3 (Recommandé)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Taux d\'échantillonnage',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (Qualité CD)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Commencer la compression',
  'audioCompress.compressing': 'Compression en cours...',
  'audioCompress.download': 'Télécharger l\'audio',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Compression réussie !',
  'audioCompress.message.failed': 'Échec de la compression, veuillez réessayer',
  'audioCompress.message.invalidFile': 'Veuillez sélectionner un fichier audio !',
  'audioCompress.message.loadError': 'Échec du chargement du fichier audio',
  
  // Settings
  'settings.title': 'Paramètres Système',
  'settings.description': 'Personnalisez votre expérience de plateforme de génération IA',
  'settings.notifications.title': 'Paramètres de Notification',
  'settings.notifications.description': 'Gérer la façon dont vous recevez les notifications',
  'settings.notifications.email': 'Notifications par Email',
  'settings.notifications.emailDesc': 'Recevoir des mises à jour importantes et des emails de fin de tâche',
  'settings.notifications.push': 'Notifications Push',
  'settings.notifications.pushDesc': 'Recevoir des messages push en temps réel',
  'settings.notifications.sound': 'Alertes Sonores',
  'settings.notifications.soundDesc': 'Jouer un son lors de l\'arrivée de notifications',
  'settings.notifications.volume': 'Volume de Notification',
  'settings.notifications.volumeDesc': 'Ajuster le volume des sons de notification',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Recevoir des événements de plateforme et des informations promotionnelles',
  'settings.interface.title': 'Apparence de l\'Interface',
  'settings.interface.description': 'Personnaliser l\'affichage de l\'interface',
  'settings.interface.theme': 'Mode de Thème',
  'settings.interface.themeDesc': 'Choisissez votre thème d\'interface préféré',
  'settings.interface.language': 'Langue',
  'settings.interface.languageDesc': 'Sélectionner la langue d\'affichage de l\'interface',
  'settings.interface.animation': 'Effets d\'Animation',
  'settings.interface.animationDesc': 'Activer les animations de transition d\'interface',
  'settings.interface.tips': 'Conseils pour Débutants',
  'settings.interface.tipsDesc': 'Afficher les guides de fonctionnalités et conseils',
  'settings.theme.light': 'Clair',
  'settings.theme.dark': 'Sombre',
  'settings.theme.auto': 'Automatique',
  'settings.ai.title': 'Paramètres de Génération IA',
  'settings.ai.description': 'Optimiser les effets et les performances de génération IA',
  'settings.ai.autoOptimize': 'Optimisation Intelligente',
  'settings.ai.autoOptimizeDesc': 'L\'IA optimise automatiquement les paramètres de génération',
  'settings.ai.quality': 'Qualité de Génération',
  'settings.ai.qualityDesc': 'Équilibre entre vitesse et qualité',
  'settings.ai.cloudSync': 'Synchronisation Cloud',
  'settings.ai.cloudSyncDesc': 'Synchroniser automatiquement les œuvres sur le cloud',
  'settings.ai.autoSave': 'Sauvegarde Automatique',
  'settings.ai.autoSaveDesc': 'Sauvegarder automatiquement les résultats après la génération',
  'settings.ai.safetyFilter': 'Filtre de Sécurité du Contenu',
  'settings.ai.safetyFilterDesc': 'Filtrer automatiquement le contenu inapproprié',
  'settings.ai.watermark': 'Ajouter un Filigrane',
  'settings.ai.watermarkDesc': 'Ajouter automatiquement un filigrane aux œuvres générées',
  'settings.ai.promptSuggestions': 'Suggestions de Prompt',
  'settings.ai.promptSuggestionsDesc': 'Recommandations intelligentes pour l\'optimisation des prompts',
  'settings.quality.fast': 'Rapide',
  'settings.quality.balanced': 'Équilibré',
  'settings.quality.high': 'Haute Qualité',
  'settings.privacy.title': 'Confidentialité et Sécurité',
  'settings.privacy.description': 'Protégez vos informations personnelles',
  'settings.privacy.profile': 'Visibilité du Profil',
  'settings.privacy.profileDesc': 'Autoriser d\'autres utilisateurs à voir votre profil',
  'settings.privacy.activity': 'Afficher le Statut d\'Activité',
  'settings.privacy.activityDesc': 'Permettre aux amis de voir votre statut en ligne',
  'settings.privacy.analytics': 'Collecte de Données Analytiques',
  'settings.privacy.analyticsDesc': 'Aidez-nous à améliorer l\'expérience produit',
  'settings.privacy.showWorks': 'Visibilité des Œuvres',
  'settings.privacy.showWorksDesc': 'Autoriser d\'autres utilisateurs à voir vos œuvres',
  'settings.privacy.allowComments': 'Autoriser les Commentaires',
  'settings.privacy.allowCommentsDesc': 'Autoriser d\'autres utilisateurs à commenter vos œuvres',
  'settings.privacy.allowDownload': 'Autoriser le Téléchargement',
  'settings.privacy.allowDownloadDesc': 'Autoriser d\'autres utilisateurs à télécharger vos œuvres',
  'settings.performance.title': 'Optimisation des Performances',
  'settings.performance.description': 'Ajuster les performances du système et l\'utilisation des ressources',
  'settings.performance.hardware': 'Accélération Matérielle',
  'settings.performance.hardwareDesc': 'Utiliser l\'accélération GPU pour le rendu',
  'settings.performance.preview': 'Qualité de Prévisualisation',
  'settings.performance.previewDesc': 'Niveau de qualité des images de prévisualisation',
  'settings.performance.autoClean': 'Nettoyage Automatique du Cache',
  'settings.performance.autoCleanDesc': 'Nettoyer régulièrement les fichiers temporaires',
  'settings.performance.imageCompression': 'Compression d\'Images',
  'settings.performance.imageCompressionDesc': 'Compresser automatiquement les images téléchargées',
  'settings.performance.lazyLoading': 'Chargement Différé',
  'settings.performance.lazyLoadingDesc': 'Retarder le chargement du contenu de la page',
  'settings.preview.low': 'Bas',
  'settings.preview.medium': 'Moyen',
  'settings.preview.high': 'Élevé',
  'settings.workflow.title': 'Paramètres de Flux de Travail',
  'settings.workflow.description': 'Personnaliser le flux de travail de génération IA',
  'settings.workflow.resolution': 'Résolution par Défaut',
  'settings.workflow.resolutionDesc': 'Taille par défaut pour la génération d\'images',
  'settings.workflow.saveHistory': 'Enregistrer l\'Historique',
  'settings.workflow.saveHistoryDesc': 'Enregistrer les paramètres de génération et l\'historique des prompts',
  'settings.workflow.autoTag': 'Tags Intelligents',
  'settings.workflow.autoTagDesc': 'Ajouter automatiquement des tags aux œuvres',
  'settings.workflow.template': 'Fonction de Modèle',
  'settings.workflow.templateDesc': 'Activer les modèles de flux de travail',
  'settings.file.title': 'Gestion des Fichiers',
  'settings.file.description': 'Gérer le stockage et la sauvegarde des fichiers',
  'settings.file.autoBackup': 'Sauvegarde Automatique',
  'settings.file.autoBackupDesc': 'Sauvegarder automatiquement les fichiers importants',
  'settings.file.backupFrequency': 'Fréquence de Sauvegarde',
  'settings.file.backupFrequencyDesc': 'Sélectionner la fréquence de sauvegarde',
  'settings.file.realtime': 'Temps Réel',
  'settings.file.daily': 'Quotidien',
  'settings.file.weekly': 'Hebdomadaire',
  'settings.file.autoOrganize': 'Organisation Intelligente',
  'settings.file.autoOrganizeDesc': 'Catégoriser et organiser automatiquement les fichiers',
  'settings.file.defaultFormat': 'Format par Défaut',
  'settings.file.defaultFormatDesc': 'Format par défaut pour l\'enregistrement des fichiers',
  'settings.social.title': 'Interaction Sociale',
  'settings.social.description': 'Gérer les fonctionnalités sociales et les permissions d\'interaction',
  'settings.social.allowFollow': 'Autoriser le Suivi',
  'settings.social.allowFollowDesc': 'Autoriser d\'autres utilisateurs à vous suivre',
  'settings.social.allowMessage': 'Autoriser les Messages',
  'settings.social.allowMessageDesc': 'Autoriser d\'autres utilisateurs à vous envoyer des messages',
  'settings.social.likeNotify': 'Notifications de J\'aime',
  'settings.social.likeNotifyDesc': 'Notifier lorsque les œuvres reçoivent des j\'aime',
  'settings.social.mentionNotify': 'Notifications de Mention',
  'settings.social.mentionNotifyDesc': 'Recevoir des notifications lors de mentions',
  'settings.security.title': 'Sécurité du Compte',
  'settings.security.description': 'Renforcer la protection de sécurité du compte',
  'settings.security.twoFactor': 'Authentification à Deux Facteurs',
  'settings.security.twoFactorDesc': 'Ajouter une couche supplémentaire de vérification de sécurité',
  'settings.security.loginNotify': 'Notifications de Connexion',
  'settings.security.loginNotifyDesc': 'Notifier lors de connexion depuis de nouveaux appareils',
  'settings.security.deviceVerify': 'Vérification d\'Appareil',
  'settings.security.deviceVerifyDesc': 'Les appareils non autorisés nécessitent une vérification',
  'settings.security.autoLogout': 'Déconnexion Automatique en Cas d\'Inactivité',
  'settings.security.autoLogoutDesc': 'Se déconnecter automatiquement après une inactivité prolongée',
  'settings.button.save': 'Enregistrer les Paramètres',
  'settings.button.reset': 'Réinitialiser par Défaut',
  'settings.badge.on': 'Activé',
  'settings.badge.recommended': 'Recommandé',
  'settings.message.saveSuccess': 'Paramètres enregistrés',
  'settings.message.autoSaved': 'Paramètres enregistrés automatiquement',
  'settings.message.saveFailed': 'Échec de l\'enregistrement, veuillez réessayer',
  'settings.message.resetSuccess': 'Paramètres réinitialisés par défaut',
  'settings.autoSaveHint': 'Les paramètres seront enregistrés automatiquement',
  'settings.confirm.resetTitle': 'Confirmer la Réinitialisation',
  'settings.confirm.resetContent': 'Êtes-vous sûr de vouloir réinitialiser tous les paramètres aux valeurs par défaut ?',
  'settings.confirm.reset': 'Réinitialiser',
  'settings.confirm.cancel': 'Annuler',

  // Prompt Version History
  'prompt.version.label.prompt': 'Prompt',
  'prompt.version.label.negativePrompt': 'Prompt Négatif',
  'prompt.version.label.result': 'Résultat',
}; 